import React, { useEffect, useRef, useState, lazy, Suspense, useCallback, useMemo } from 'react';
import { useAuth } from './AuthContext';
import './DecolagemMarte.css';
import './LojaEspacial.css';
import TelemetryDisplay from './TelemetryDisplay';
import SpaceView from './SpaceView';
import { useAudio } from './AudioManager';
import RouteMonitor from './RouteMonitor';
import MissionTimer from './MissionTimer';
import SpeedGauge from './SpeedGauge';
import MandalaVirtudes from './MandalaVirtudes';
import { usePause } from './PauseContext';
import Inventario from './Inventario';
import desafiosData from './desafios.json';
import ModalEscolha from './ModalEscolha';
import { useSpaceCoins } from './SpaceCoinsContext';
import ModalDesafio from './ModalDesafio';
import ModalConfirmacaoViagem from './ModalConfirmacaoViagem';
import { useConfig } from './ConfigContext';
import LojaEspacial from './LojaEspacial';
import { useLocation, useNavigate } from 'react-router-dom';

// --- CONSTANTES DE DADOS DA TRIPULAÇÃO ---
const TEAMS_DATA = [
  { id: 1, code: "E1", description: "Equipe especializada em exploração", missions: 12, achievements: ["Primeira equipe a mapear o Cinturão de Asteroides X-47", "Desenvolveu sistema de navegação em ambientes de alta gravidade", "Recorde de permanência em ambientes hostis: 487 dias"], members: [{ role: "Coordenador Espacial", name: "Sisifo", experience: "45 anos", details: "Engenheiro Aeroespacial", country: "Espanha" }, { role: "Cientista", name: "Neo", experience: "39 anos", details: "Cientista de Recursos Naturais Raros e Astrobotânica", country: "Americano" }, { role: "Engenheira", name: "Tamara", experience: "32 anos", details: "Física e Engenheira Aero Espacial", country: "Americana" }, { role: "Engenheira", name: "Ares", experience: "39 anos", details: "Engenheira Aeronáutico, PhD em Sist. de Oxigenação sob condições adversas", country: "Espanha" }, { role: "Engenheira", name: "Mae", experience: "37 anos", details: "Engenheira Química, PhD", country: "Americana" }] },
  { id: 2, code: "E2", description: "Equipe especializada em diplomacia", missions: 18, achievements: ["Mediou conflito intercolonial em Marte (2147)", "Equipe com maior índice de resolução pacífica de incidentes", "Desenvolveu protocols de comunicação intercultural"], members: [{ role: "Coordenadora Espacial", name: "Aletheia", experience: "40 anos", details: "Engenharia Aeronáutica", country: "Romena" }, { role: "Capitão", name: "Kirk", experience: "30 anos", details: "Ergo. Químico, PhD em Matemática e Pepito Espacial", country: "Americano" }, { role: "Cientista", name: "Maureen", experience: "43 anos", details: "Ergo. Astrofísica, PhD em Geometria Espacial", country: "Canadense" }, { role: "Piloto", name: "Hazza Ali", experience: "37 anos", details: "Piloto Militar", country: "Árabe" }, { role: "Engenheiro", name: "Ilia Ramon", experience: "49 anos", details: "Ergo. Aeronáutico e Piloto de Caça", country: "Israelense" }] },
  { id: 3, code: "E3", description: "Equipe especializada em combate", missions: 24, achievements: ["Defesa bem-sucedida da Base Lunar Alpha contra ataque de 2149", "Treinou 87% dos pilotos de combate ativos", "Desenvolveu táticas de defesa em gravidade zero"], members: [{ role: "Coordenador Espacial", name: "Kopenawa", experience: "55 anos", details: "Astrofísico e Engenheiro Espacial", country: "Mexicano" }, { role: "Médico", name: "Marek", experience: "47 anos", details: "Psiquiatra Psicanalista, PhD em Doenças Pós-Espaciais", country: "Tcheco" }, { role: "Nutricionista", name: "Farna", experience: "34 anos", details: "Nutricionista Espacial", country: "Polonesa" }, { role: "Biólogo", name: "Zachary", experience: "42 anos", details: "Biólogo e Infectologista, PhD", country: "Americano" }, { role: "Engenheiro", name: "Iuri", experience: "30 anos", details: "Ergo. Aeronáutico e músico", country: "Ítalo-russo" }, { role: "Tripulante convidada", name: "Zahy", experience: "35 anos", details: "Indígena brasileira", country: "Brasileira" }] },
  { id: 4, code: "E4", description: "Equipe especializada em pesquisa", missions: 15, achievements: ["Descoberta de 3 novos elementos em asteroides", "Desenvolveu sistema de análise de solo planetário em tempo real", "Publicou 47 artigos científicos em revistas de prestígio"], members: [{ role: "Coordenadora Espacial", name: "Deméter", experience: "42 anos", details: "Geóloga espacial, PhD", country: "Canadense" }, { role: "Engenheiro", name: "Semolek", experience: "40 anos", details: "Ergo. Especialista em Sist. de Sensores Espaciais e Aéreos", country: "Russo" }, { role: "Engenheira", name: "Nora", experience: "27 anos", details: "Engenheira Mecânica Especialista em Eventos Espaciais Atípicos", country: "Árabe" }, { role: "Física", name: "Liu", experience: "43 anos", details: "Física Nuclear", country: "Chinesa" }, { role: "Engenheiro", name: "Pétros", experience: "34 anos", details: "Engenheiro de Sistemas", country: "Grego" }] },
  { id: 5, code: "E5", description: "Equipe especializada em engenharia", missions: 21, achievements: ["Projetou o sistema de propulsão usado em 78% das naves atuais", "Recorde de reparos em órbita: 147 em missão única", "Desenvolveu materiais autoregenerativos para cascos de nave"], members: [{ role: "Coordenador Espacial", name: "Aguiles", experience: "35 anos", details: "Ergo. Mecânico Aero Espacial", country: "Italiano" }, { role: "Engenheiro", name: "Noguchi", experience: "38 anos", details: "Engenheiro Aeronáutico", country: "Japonês" }, { role: "Médica", name: "Chiaki", experience: "46 anos", details: "Médica, PhD em doenças espaciais", country: "Japonesa" }, { role: "Engenheiro", name: "Gorjah", experience: "32 anos", details: "Eng. Elétrico PhD em Logística Espacial", country: "Americano" }, { role: "Astrobiólogo", name: "Atena", experience: "38 anos", details: "Astrobiólogo, PhD", country: "Russa" }] }
];

const getMemberImage = (teamCode, index) => {
  switch (teamCode) {
    case 'E1': return index === 0 ? 'Sisifo' : index === 1 ? 'neo_steves' : index === 2 ? 'Tamara' : index === 3 ? 'Ares' : 'Mae';
    case 'E2': return index === 0 ? 'Aletheia' : index === 1 ? 'Capitao_Kirk' : index === 2 ? 'Dr_Maureen' : index === 3 ? 'Hazza_Ali' : 'Illa_Ramon';
    case 'E3': return index === 0 ? 'Kopenawa' : index === 1 ? 'Marek' : index === 2 ? 'Farna' : index === 3 ? 'Zachary' : index === 4 ? 'Iuri' : 'Zahy';
    case 'E4': return index === 0 ? 'Demeter' : index === 1 ? 'Semolek' : index === 2 ? 'Nora' : index === 3 ? 'Liu' : 'Petros';
    case 'E5': return index === 0 ? 'Aquiles' : index === 1 ? 'Noguchi' : index === 2 ? 'dra_chiaki' : index === 3 ? 'Gorjah' : 'Atena';
    default: return index === 0 ? 'default1' : index === 1 ? 'default2' : index === 2 ? 'default3' : index === 3 ? 'default4' : 'default5';
  }
};

const getShipImage = (shipName) => {
  if (!shipName) return '/images/NeoEclipseDigital.webp'; // Fallback

  switch (shipName.toUpperCase()) {
    case 'ARTEMIS1':
      return '/images/Artemis1Digital.webp';
    case 'OBERONX':
      return '/images/OberonXDigital.webp';
    case 'GAIANOVA':
      return '/images/GaiaNovaDigital.webp';
    case 'STRATUSV':
      return '/images/StrausVDigital.webp';
    case 'NEOECLIPSE':
      return '/images/NeoEclipseDigital.webp';
    default:
      return '/images/NeoEclipseDigital.webp';
  }
};
// --- COMPONENTE DE TEXTO DIGITADO (HUD) ---
const TypewriterText = ({ label, value }) => {
  const [displayedValue, setDisplayedValue] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const valueRef = useRef(value);

  // Mantém o valor sempre atualizado
  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  useEffect(() => {
    let isMounted = true;
    let index = 0;
    let typingInterval;
    let cycleTimeout;

    const startTyping = () => {
      setIsTyping(true);
      setDisplayedValue('');
      index = 0;
      const currentTargetString = valueRef.current != null ? String(valueRef.current) : '';

      typingInterval = setInterval(() => {
        if (index < currentTargetString.length) {
          setDisplayedValue(currentTargetString.substring(0, index + 1));
          index++;
        } else {
          clearInterval(typingInterval);
          if (isMounted) setIsTyping(false);

          // Aguarda 10 segundos e reinicia o ciclo
          cycleTimeout = setTimeout(() => {
            if (isMounted) startTyping();
          }, 10000);
        }
      }, 60); // Velocidade de digitação
    };

    startTyping();

    return () => {
      isMounted = false;
      clearInterval(typingInterval);
      clearTimeout(cycleTimeout);
    };
  }, []);

  return (
    <div style={{ marginBottom: '4px' }}>
      {label}: {isTyping ? displayedValue : value}<span className="blinking-cursor">_</span>
    </div>
  );
};

// --- COMPONENTE DE RADAR DINÂMICO (AJUSTADO) ---
const DynamicRadar = ({ progress, origin, destination, sosSignal }) => {
  // Planeta de Destino (Destacado em ciano)
  const destY = 10 + (progress / 100) * 40;
  const destX = 50;

  // Planeta de Origem (Destacado em uma cor neutra/clara)
  const origY = 50 + (progress / 100) * 40;
  const origX = 50;

  const getBlipStyle = (x, y, color, size) => ({
    top: `${y}%`,
    left: `${x}%`,
    backgroundColor: color,
    boxShadow: `0 0 4px ${color}, 0 0 10px ${color}`,
    width: `${size}px`,
    height: `${size}px`,
    animationDelay: `${(x / 100) * 3}s`
  });

  return (
    <div className="space-radar-wrapper">
      <div className="space-radar">
        <div className="radar-grid"></div>
        <div className="radar-sweep"></div>

        {/* Planeta de Origem - Cor de destaque branca ou cinza claro */}
        <div
          className="dynamic-blip"
          style={getBlipStyle(origX, origY, '#ffffff', 5)}
          title={`Origem: ${origin?.nome || 'Terra'}`}
        ></div>

        {/* Planeta de Destino - Cor de destaque ciano */}
        <div
          className="dynamic-blip"
          style={getBlipStyle(destX, destY, '#0bf', 6)}
          title={`Destino: ${destination?.nome || 'Desconhecido'}`}
        ></div>

        {/* Sinal de S.O.S (Mantido caso precise de alerta) */}
        {sosSignal && (
          <div
            className="dynamic-blip sos-blink"
            style={getBlipStyle(
              50 + Math.cos(sosSignal.angle * Math.PI / 180) * 35,
              50 + Math.sin(sosSignal.angle * Math.PI / 180) * 35,
              '#f00', 6
            )}
            title="SINAL S.O.S DETETADO!"
          ></div>
        )}
      </div>
    </div>
  );
};

// --- COMPONENTES OTIMIZADOS (React.memo com Custom Comparators) ---

// 1. Painel Esquerdo
const LeftControlPanel = React.memo(({
  telemetry, distanceKm, progress, isDobraAtivada, isDobraEnabled, isPaused,
  originPlanet, destinationPlanet, maxSpeed, isBoosting,
  handleDobraEspacial, handleInventory, minervaImage, handleMinervaClick,
  isMinervaHighlighted, processadorO2, isO2TransferDisabled, handleOpenO2Modal,
  mainDisplayState
}) => {
  return (
    <div className="left-panel-3d">
      <div style={{ marginTop: '-30px' }}>
        <RouteMonitor
          distanceKm={distanceKm}
          progress={progress}
          currentSpeed={telemetry.velocity.kmh}
          isDobraAtivada={isDobraAtivada}
          originPlanet={originPlanet}
          destinationPlanet={destinationPlanet}
          mainDisplayState={mainDisplayState}
        />
      </div>
      <div className="dobra-buttons-container">
        <div className="dobra-btn-wrapper">
          <button
            type="button"
            className={`ativar-de-btn ${isDobraAtivada ? 'active' : ''} ${!isDobraEnabled || isPaused || distanceKm <= 0 ? 'disabled' : ''}`}
            onClick={(e) => { e.preventDefault(); handleDobraEspacial(); }}
            disabled={!isDobraEnabled || isPaused || distanceKm <= 0}
          >
            {isDobraAtivada ? <>Dobra<br />Ativa</> : <>Dobra<br />Espacial</>}
          </button>
        </div>
        <div className="dobra-btn-wrapper">
          <button type="button" className="inventory-btn" onClick={(e) => { e.preventDefault(); handleInventory(); }} disabled={isPaused}>Inventário</button>
        </div>
      </div>
      <SpeedGauge
        currentSpeed={telemetry.velocity.kmh}
        maxSpeed={maxSpeed}
        isBoosting={isBoosting}
        isDobraAtivada={isDobraAtivada}
      />
      <div className="minerva-section">
        <div
          className={`minerva-title ${isMinervaHighlighted ? 'highlighted' : ''}`}
          onClick={handleMinervaClick}
          style={{ cursor: 'pointer', zIndex: 10, position: 'relative' }}
        >
          MINERVA I.A.
        </div>
        <div className="minerva-container" onClick={handleMinervaClick} style={{ cursor: 'pointer' }}>
          <img
            src={minervaImage}
            alt="Minerva Status"
            className={`minerva-image ${isMinervaHighlighted ? 'minerva-rainbow-glow' : ''}`}
          />
        </div>
      </div>
      <div className="o2-processor-display">
        <span className="o2-processor-label">
          PROCESSADOR <span style={{ fontSize: '1.4em', fontWeight: '900', color: '#0bf', textShadow: '0 0 10px #0bf' }}>O</span><sub style={{ fontSize: '0.66em', verticalAlign: 'sub', color: '#0bf', textShadow: '0 0 10px #0bf' }}>2</sub>
        </span>
        <div className="o2-meter-visual">
          {[1, 2, 3, 4, 5].map(unit => (<div key={unit} className={`o2-unit ${processadorO2 >= unit ? 'filled' : ''}`}></div>))}
        </div>
        <button
          type="button"
          className={`o2-transfer-button ${isO2TransferDisabled ? 'disabled' : ''}`}
          onClick={(e) => { e.preventDefault(); handleOpenO2Modal(); }}
          disabled={isO2TransferDisabled}
          style={{ zIndex: 100 }}
        >
          TRANSFERIR ({processadorO2})
        </button>
      </div>
    </div>
  );
}, (prevProps, nextProps) => {
  return (
    prevProps.distanceKm === nextProps.distanceKm &&
    prevProps.progress === nextProps.progress &&
    prevProps.isDobraAtivada === nextProps.isDobraAtivada &&
    prevProps.isDobraEnabled === nextProps.isDobraEnabled &&
    prevProps.isPaused === nextProps.isPaused &&
    prevProps.originPlanet === nextProps.originPlanet &&
    prevProps.destinationPlanet === nextProps.destinationPlanet &&
    prevProps.maxSpeed === nextProps.maxSpeed &&
    prevProps.isBoosting === nextProps.isBoosting &&
    prevProps.minervaImage === nextProps.minervaImage &&
    prevProps.isMinervaHighlighted === nextProps.isMinervaHighlighted &&
    prevProps.processadorO2 === nextProps.processadorO2 &&
    prevProps.isO2TransferDisabled === nextProps.isO2TransferDisabled &&
    prevProps.mainDisplayState === nextProps.mainDisplayState &&
    prevProps.telemetry.velocity.kmh === nextProps.telemetry.velocity.kmh
  );
});

// 2. Painel Direito
const RightMonitorPanel = React.memo(({
  isPaused, isTransmissionStarting, isDialogueFinished, handleReplayDialogue,
  handleNextDialogue, monitorState, showMinervaOnMonitor,
  showCriticalWarpFail, showWarpDisabledMessage, isForcedMapEdit, isSosMinervaActive,
  isDeparting, currentCharacterData, currentDialogueStep, highlightKeywords,
  setShowGlossary, handleInventory, teamPhotoUrl, API_BASE_URL,
  isSOSActive, handleSOS, hasFundsForSOS, isRestoringSOS, togglePause, isPauseButtonDisabled,
  setShowTeamModal
}) => {
  return (
    <div className="right-panel-3d" style={{ zIndex: 50 }}>
      <MissionTimer isPaused={isPaused} />

      {/* MONITOR SUPERIOR */}
      <div className="right-monitor-container">
        <div className="monitor-controls">
          <span className={`rec-label ${isTransmissionStarting ? 'blinking-rec' : 'inactive-rec'}`}>REC</span>
          <button
            type="button"
            className={`play-button ${isDialogueFinished ? 'pulsing-play' : ''}`}
            onClick={(e) => { e.preventDefault(); handleReplayDialogue(); }}
            disabled={!isDialogueFinished || isPaused}
          >
            Play
          </button>
        </div>
        <div className="monitor-screen">
          {isSosMinervaActive && !isDeparting && !isForcedMapEdit ? (
            <img src="/images/Minerva/Minerva-Informando-velocidade.gif" alt="Alerta S.O.S Minerva" className="monitor-image" />
          ) : showCriticalWarpFail ? (
            <div className="monitor-text-display" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', backgroundColor: 'rgba(30, 0, 0, 0.9)', flexDirection: 'column', padding: '10px' }}>
              <h3 style={{ color: '#ff3333', margin: '0 0 10px 0', textShadow: '0 0 10px red', fontSize: '1.1rem', textAlign: 'center' }}>⚠ FALHA CRÍTICA ⚠</h3>
              <p style={{ color: '#ffaaaa', textAlign: 'center', fontWeight: 'bold', fontSize: '0.9rem', lineHeight: '1.4', margin: 0 }}>Elementos base para a dobra escassos.<br />Recursos direcionados para<br />suporte à vida.</p>
            </div>
          ) : isForcedMapEdit ? (
            <div className="monitor-text-display" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', backgroundColor: 'rgba(50, 0, 0, 0.5)' }}>
              <p style={{ color: '#ffcc00', textAlign: 'center', fontWeight: 'bold', textShadow: '0 0 5px red' }}>⚠ ATENÇÃO ⚠<br /><br />Edite o Mapa Estelar e mude a rota para fechar.</p>
            </div>
          ) : isTransmissionStarting && currentCharacterData?.imagem ? (
            <img src={currentCharacterData.imagem} alt={currentCharacterData.nome} className="monitor-image" />
          ) : (
            <>
              {showWarpDisabledMessage ? (
                <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: '#ff0', textAlign: 'center', padding: '10px', fontSize: '0.9em', textShadow: '0 0 5px rgba(255, 255, 0, 0.7)' }}>Distancia Orbital máxima alcançada.<br />Dobra desativada!</div>
              ) : showMinervaOnMonitor ? (
                <img src="/images/Minerva/Minerva-Informando-velocidade.gif" alt="Aviso de Velocidade" className="monitor-image" />
              ) : (
                <>
                  {monitorState === 'on' && <img src="/images/ACEE.png" alt="Ecrã do Monitor" className="monitor-image" />}
                  {monitorState === 'static' && <img src="/images/No_Signal.png" alt="Ecrã do Monitor" className="monitor-image" style={{ filter: 'brightness(1.2) contrast(1.5)', animation: 'staticFlicker 0.1s infinite alternate' }} />}
                </>
              )}
            </>
          )}
        </div>
      </div>

      {/* MONITOR INFERIOR */}
      <div className="right-monitor-container" style={{ marginTop: '10px' }}>
        <div className="monitor-screen" onClick={isTransmissionStarting ? handleNextDialogue : undefined} style={{ cursor: isTransmissionStarting ? 'pointer' : 'default' }}>
          {isTransmissionStarting && currentDialogueStep && currentCharacterData ? (
            <div className="monitor-text-display">
              <p><span className="dialogue-character-name" style={{ color: '#00aaff' }}>{currentCharacterData.nome}:</span>{' '}{highlightKeywords(currentDialogueStep.texto, currentDialogueStep.palavras_chave)}</p>
              <div style={{ textAlign: 'right', fontSize: '0.8em', color: '#00aaff', animation: 'blink 1s infinite' }}>▼</div>
            </div>
          ) : (
            <>
              {monitorState === 'on' && <img src="/images/ACEE.png" alt="Ecrã do Monitor" className="monitor-image" />}
              {monitorState === 'static' && <img src="/images/No_Signal.png" alt="Ecrã do Monitor" className="monitor-image" style={{ filter: 'brightness(1.2) contrast(1.5)', animation: 'staticFlicker 0.1s infinite alternate' }} />}
            </>
          )}
        </div>
      </div>

      {/* BOTOES EQUIPE E GLOSSARIO LADO A LADO */}
      <div className="glossary-button-container" style={{ marginTop: '15px', position: 'relative', zIndex: 10 }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '10px', width: '100%' }}>
          <button
            type="button"
            className="glossary-button shine-effect"
            onClick={(e) => { e.preventDefault(); if (!isPaused) setShowTeamModal(true); }}
            disabled={isPaused}
            style={{ flex: 1, backgroundColor: 'rgba(0, 150, 255, 0.2)', margin: 0, padding: '8px 0', textAlign: 'center' }}
          >
            EQUIPE
          </button>
          <button
            type="button"
            className="glossary-button shine-effect"
            onClick={(e) => { e.preventDefault(); if (!isPaused) setShowGlossary(true); }}
            disabled={isPaused}
            style={{ flex: 1, margin: 0, padding: '8px 0', textAlign: 'center' }}
          >
            GLOSSÁRIO
          </button>
          <button type="button" className="bolsa-button" onClick={(e) => { e.preventDefault(); handleInventory(); }} disabled={true} title="Bolsa Espacial (Indisponível)" style={{ opacity: 0.5, cursor: 'not-allowed', margin: 0, flexShrink: 0 }}>
            <img src="/images/BolsaEspacial.png" alt="Bolsa Espacial" style={{ width: '60px', height: 'auto' }} />
          </button>
        </div>
      </div>

      {/* IMAGEM DA TRIPULACAO ABAIXO DOS BOTÕES */}
      {teamPhotoUrl && (
        <div className="team-photo-frame">
          <div className="team-photo-header">TRIPULAÇÃO</div>
          <img src={`${API_BASE_URL}${teamPhotoUrl}`} alt="Equipe" className="team-photo-img" onError={(e) => { e.target.style.display = 'none'; }} />
          <div className="team-photo-overlay"></div>
        </div>
      )}

      {/* BOTÕES FLUTUANTES (Pausa e S.O.S) COM HVS-21 AO LADO */}
      <div className="floating-buttons-container">
        <button
          type="button"
          onClick={(e) => { e.preventDefault(); togglePause(); }}
          disabled={isPauseButtonDisabled || isRestoringSOS}
          className={`pause-button ${isPaused ? 'paused' : ''}`}
          title={isRestoringSOS ? "Não é possível pausar durante a restauração S.O.S." : ""}
        >
          {isPaused ? 'Continuar Jogo' : 'Pausar Jogo'}
        </button>
        <button
          type="button"
          className={`sos-button ${isSOSActive ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); handleSOS(); }}
          disabled={!isSOSActive}
          title={isSOSActive ? "Ativar S.O.S." : !hasFundsForSOS ? "Sem SpaceCoins para S.O.S." : "S.O.S. indisponível"}
        >
          S.O.S.
        </button>
        <img src="/images/HVS-21.png" alt="HVS-21" className="hvs-logo" onError={(e) => { e.target.style.display = 'none'; }} />
      </div>
    </div>
  );
}, (prevProps, nextProps) => {
  return (
    prevProps.isPaused === nextProps.isPaused &&
    prevProps.isTransmissionStarting === nextProps.isTransmissionStarting &&
    prevProps.isDialogueFinished === nextProps.isDialogueFinished &&
    prevProps.monitorState === nextProps.monitorState &&
    prevProps.showMinervaOnMonitor === nextProps.showMinervaOnMonitor &&
    prevProps.showCriticalWarpFail === nextProps.showCriticalWarpFail &&
    prevProps.showWarpDisabledMessage === nextProps.showWarpDisabledMessage &&
    prevProps.isForcedMapEdit === nextProps.isForcedMapEdit &&
    prevProps.isSosMinervaActive === nextProps.isSosMinervaActive &&
    prevProps.isDeparting === nextProps.isDeparting &&
    prevProps.currentCharacterData === nextProps.currentCharacterData &&
    prevProps.currentDialogueStep === nextProps.currentDialogueStep &&
    prevProps.teamPhotoUrl === nextProps.teamPhotoUrl &&
    prevProps.isSOSActive === nextProps.isSOSActive &&
    prevProps.hasFundsForSOS === nextProps.hasFundsForSOS &&
    prevProps.isRestoringSOS === nextProps.isRestoringSOS &&
    prevProps.isPauseButtonDisabled === nextProps.isPauseButtonDisabled
  );
});

// 3. Janela Principal
const MainDisplayWindow = React.memo(({
  mainDisplayState, isDobraAtivada, distanceKm, arrivedAtMars, isPaused,
  selectedPlanet, handleChallengeEnd, isDeparting, showStoreModal,
  showSosSurprise, sosSurpriseEvent, handleSeguirPlano, handleMudarRota,
  handleStoreChallengeImpact, telemetry, plannedRoute, routeIndex
}) => {
  const cloudsVideoRef = useRef(null);
  const dobraVideoRef = useRef(null);

  useEffect(() => {
    const warmUpVideos = async () => {
      try {
        if (cloudsVideoRef.current) {
          cloudsVideoRef.current.muted = true;
          await cloudsVideoRef.current.play();
          cloudsVideoRef.current.pause();
          cloudsVideoRef.current.currentTime = 0;
        }
        if (dobraVideoRef.current) {
          dobraVideoRef.current.muted = true;
          await dobraVideoRef.current.play();
          dobraVideoRef.current.pause();
          dobraVideoRef.current.currentTime = 0;
        }
      } catch (e) {
        // Navegador bloqueou o autoplay do warm-up; comportamento esperado, ignora.
      }
    };
    warmUpVideos();
  }, []);

  useEffect(() => {
    let timeout;
    if (mainDisplayState === 'clouds' && cloudsVideoRef.current) {
      setTimeout(() => {
        if (cloudsVideoRef.current) cloudsVideoRef.current.play().catch(() => { });
      }, 50);
    } else if (cloudsVideoRef.current) {
      timeout = setTimeout(() => {
        if (cloudsVideoRef.current) {
          cloudsVideoRef.current.pause();
          cloudsVideoRef.current.currentTime = 0;
        }
      }, 150);
    }
    return () => clearTimeout(timeout);
  }, [mainDisplayState]);

  useEffect(() => {
    let timeout;
    if (isDobraAtivada && dobraVideoRef.current) {
      setTimeout(() => {
        if (dobraVideoRef.current) {
          dobraVideoRef.current.play().catch(() => { });
        }
      }, 50);
    } else if (dobraVideoRef.current) {
      timeout = setTimeout(() => {
        if (dobraVideoRef.current) {
          dobraVideoRef.current.pause();
          dobraVideoRef.current.currentTime = 0;
        }
      }, 150);
    }
    return () => clearTimeout(timeout);
  }, [isDobraAtivada]);

  return (
    <div className="main-display">
      {mainDisplayState === 'acee' && (<img src="/images/ACEE.png" alt="ACEE" style={{ maxWidth: '80%', maxHeight: '80%', objectFit: 'contain', position: 'absolute', zIndex: 10 }} />)}

      <video
        ref={cloudsVideoRef}
        src="/images/clouds.webm"
        className="cloud-animation-video"
        muted
        playsInline
        preload="auto"
        style={{
          opacity: mainDisplayState === 'clouds' ? 1 : 0,
          pointerEvents: mainDisplayState === 'clouds' ? 'auto' : 'none',
          position: 'absolute',
          zIndex: mainDisplayState === 'clouds' ? 5 : -1,
          transition: 'opacity 0.1s ease-in-out',
          willChange: 'opacity',
          transform: 'translateZ(0)'
        }}
      />

      <video
        ref={dobraVideoRef}
        src="/images/Vluz-Dobra.webm"
        loop
        muted
        playsInline
        preload="auto"
        style={{
          opacity: isDobraAtivada ? 1 : 0,
          pointerEvents: isDobraAtivada ? 'auto' : 'none',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          position: 'absolute',
          zIndex: isDobraAtivada ? 8 : -1,
          transition: 'opacity 0.1s ease-in-out',
          willChange: 'opacity',
          transform: 'translateZ(0)'
        }}
      />

      {mainDisplayState === 'static' && <div className="static-animation" style={{ position: 'absolute', width: '100%', height: '100%', zIndex: 6 }}></div>}

      <div style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        opacity: (mainDisplayState === 'stars' && !isDobraAtivada) ? 1 : 0.01,
        pointerEvents: (mainDisplayState === 'stars' && !isDobraAtivada) ? 'auto' : 'none',
        zIndex: 3,
        transition: 'opacity 0.4s ease'
      }}>
        <SpaceView
          distance={distanceKm}
          forceLarge={arrivedAtMars}
          isWarpActive={isDobraAtivada}
          isPaused={isPaused}
          selectedPlanet={selectedPlanet}
          onChallengeEnd={handleChallengeEnd}
          isDeparting={isDeparting}
          isActive={mainDisplayState === 'stars'}
        />
      </div>

      {showStoreModal && (
        <LojaEspacial
          onClose={() => { }}
          currentTelemetry={telemetry}
          onSeguirPlano={handleSeguirPlano}
          onMudarRota={handleMudarRota}
          onChallengeAccepted={handleStoreChallengeImpact}
          isMainDisplayModal={true}
          currentStation={selectedPlanet?.nome}
          hasRoute={plannedRoute && (routeIndex + 1) < plannedRoute.length}
        />
      )}
      {showSosSurprise && sosSurpriseEvent && (
        <SosSurpriseModal
          event={sosSurpriseEvent}
          onMudarRota={handleMudarRota}
          onSeguirPlano={handleSeguirPlano}
          hasRoute={plannedRoute && (routeIndex + 1) < plannedRoute.length}
        />
      )}
    </div>
  );
}, (prevProps, nextProps) => {
  return (
    prevProps.mainDisplayState === nextProps.mainDisplayState &&
    prevProps.isDobraAtivada === nextProps.isDobraAtivada &&
    prevProps.distanceKm === nextProps.distanceKm &&
    prevProps.arrivedAtMars === nextProps.arrivedAtMars &&
    prevProps.isPaused === nextProps.isPaused &&
    prevProps.selectedPlanet?.nome === nextProps.selectedPlanet?.nome &&
    prevProps.isDeparting === nextProps.isDeparting &&
    prevProps.showStoreModal === nextProps.showStoreModal &&
    prevProps.showSosSurprise === nextProps.showSosSurprise &&
    prevProps.sosSurpriseEvent === nextProps.sosSurpriseEvent &&
    prevProps.routeIndex === nextProps.routeIndex &&
    prevProps.plannedRoute === nextProps.plannedRoute &&
    prevProps.telemetry.velocity.kmh === nextProps.telemetry.velocity.kmh
  );
});

// --- UTILS & MODALS ---
const SosSurpriseModal = ({ event, onClose, onMudarRota, onSeguirPlano, hasRoute }) => {
  if (!event) return null;
  const getRiskColor = (id) => {
    switch (id) {
      case 1: return '#ff4444';
      case 2: return '#ffaa00';
      case 3: return '#00ccff';
      default: return '#aaaaaa';
    }
  };
  const riskColor = getRiskColor(event.id);
  const containerStyle = { borderColor: riskColor, boxShadow: `0 0 30px ${riskColor}66` };
  return (
    <div className="store-modal-overlay main-display-overlay">
      <div className="store-modal-container" style={containerStyle}>
        <div className="store-header" style={{ borderBottomColor: `${riskColor}4D` }}>
          <h2 style={{ color: riskColor, textShadow: `0 0 8px ${riskColor}80` }}>RELATÓRIO DE S.O.S</h2>
        </div>
        <div className="store-grid challenges-mode" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <div className="store-item" style={{ width: '100%', maxWidth: '800px', borderColor: riskColor, flexDirection: 'row', display: 'flex', gap: '20px', alignItems: 'center' }}>
            <img src={event.image} alt={event.name} className="store-item-image" style={{ width: '200px', height: '200px', objectFit: 'contain', filter: 'drop-shadow(0 0 10px rgba(0,0,0,0.5))' }} onError={(e) => { e.target.src = '/images/ACEE.png'; }} />
            <div className="store-item-details" style={{ textAlign: 'left' }}>
              <div className="store-item-name" style={{ color: riskColor, fontSize: '2rem', marginBottom: '15px' }}>{event.name}</div>
              <div className="description-wrapper">
                <div className="store-item-description" style={{ fontSize: '1.2rem', lineHeight: '1.6', color: '#eee' }}>{event.description}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="store-action-buttons" style={{ position: 'relative', justifyContent: 'center', marginTop: '20px', bottom: 'auto', right: 'auto' }}>
          <button type="button" className="buy-button action-button-mudar" onClick={(e) => { e.preventDefault(); onMudarRota(); }} style={{ padding: '15px 30px', fontSize: '1.1rem' }}>MUDAR ROTA</button>
          {hasRoute && (
            <button type="button" className="buy-button action-button-seguir" onClick={(e) => { e.preventDefault(); onSeguirPlano(); }} style={{ padding: '15px 30px', fontSize: '1.1rem' }}>SEGUIR PLANO</button>
          )}
        </div>
      </div>
    </div>
  );
};

const GalacticVirtudesPage = lazy(() => import('./GalacticVirtudesPage').catch(() => ({
  default: () => <div className="map-fallback">Glossário Indisponível</div>
})));

const PLANET_DATA_FOR_SOS = [
  { name: "Mercúrio", orbitRadius: 20 }, { name: "Venus", orbitRadius: 30 }, { name: "Terra", orbitRadius: 40 },
  { name: "Marte", orbitRadius: 50 }, { name: "Jupiter", orbitRadius: 80 }, { name: "Saturno", orbitRadius: 100 },
  { name: "Urano", orbitRadius: 120 }, { name: "Netuno", orbitRadius: 140 }, { name: "Plutao", orbitRadius: 150 },
  { name: "Ceres", orbitRadius: 60 }, { name: "Eris", orbitRadius: 165 }
];
const STATION_NAMES = ['acee', 'almaz', 'mol', 'tiangong', 'skylab', 'salyut', 'delfos', 'boctok'];

// --- LISTA DE S.O.S ---
const SOS_EVENTS_LIST = [
  { id: 1, name: 'Piratas Espaciais', description: 'ALERTA! O sinal era uma isca. Piratas interceptaram a nave. Prepare-se para um possível confronto ou negociação hostil.', image: '/images/pirates.png' },
  { id: 2, name: 'Astronauta Morto', description: 'Encontramos um traje à deriva. Infelizmente, não há sinais vitais. Podemos recuperar equipamentos e dados da missão dele.', image: '/images/dead_astronaut.png' },
  { id: 3, name: 'Nave Destruída', description: 'Destroços de uma antiga batalha ou acidente. Há muita sucata valiosa e contêineres que podem conter recursos úteis.', image: '/images/destroyed_ship.png' },
  { id: 4, name: 'Objeto Alienígena', description: 'Identificamos um artefato de origem desconhecida emitindo o sinal. Sua tecnologia parece avançada e fora dos padrões da ACEE.', image: '/images/static_signal.png' }
];

const hasWaterList = new Set([
  "Marte", "Mercúrio", "Ceres", "Plutão", "Haumea", "Eris", "Makemake", "Lua", "Europa", "Ganímedes",
  "Calisto", "Titã", "Encelado", "Tritão", "Caronte", "Titania", "Oberon", "Vesta", "Trappist1e",
  "Kepler186f", "Terra", "Proxima Centauri b"
]);

const degradationRates = {
  default: { nuclearPropulsion: 8.75, oxygen: 10, stability: 10, direction: 10, productivity: 11.25, interdependence: 11.25, engagement: 11.25 },
  ARTEMIS1: { nuclearPropulsion: 15, oxygen: 10, stability: 13.75, direction: 13.75, productivity: 11.25, interdependence: 11.25, engagement: 11.25 },
  OBERONX: { nuclearPropulsion: 11.25, oxygen: 16.25, stability: 17.5, direction: 17.5, productivity: 15, interdependence: 15, engagement: 15 },
  GAIANOVA: { nuclearPropulsion: 8.75, oxygen: 12.5, stability: 10, direction: 10, productivity: 18.75, interdependence: 18.75, engagement: 18.75 },
  STRATUSV: { nuclearPropulsion: 6.25, oxygen: 7.5, stability: 8.75, direction: 8.75, productivity: 7.5, interdependence: 7.5, engagement: 7.5 },
  NEOECLIPSE: { nuclearPropulsion: 3.75, oxygen: 5, stability: 6.25, direction: 6.25, productivity: 8.75, interdependence: 8.75, engagement: 8.75 }
};
const accelerationRates = {
  default: { perTick: 60 }, GAIANOVA: { perTick: 40 }, ARTEMIS1: { perTick: 55 },
  OBERONX: { perTick: 60 }, STRATUSV: { perTick: 90 }, NEOECLIPSE: { perTick: 150 },
};
const takeoffDegradation = {
  default: { propulsion: 2, direction: 1, stability: 2 },
  NEOECLIPSE: { propulsion: 4, direction: 3, stability: 5 },
  STRATUSV: { propulsion: 3, direction: 2, stability: 4 },
  GAIANOVA: { propulsion: 3, direction: 2, stability: 3 },
  ARTEMIS1: { propulsion: 2, direction: 1, stability: 2 },
  OBERONX: { propulsion: 1, direction: 0, stability: 1 },
};

const normalizeName = (str) => str ? str.toString().toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/-/g, "").replace(/\s+/g, "") : "";

const highlightKeywords = (text, keywords) => {
  if (!keywords || keywords.length === 0 || !text) return text;
  const regex = new RegExp(`(${keywords.join('|')})`, 'gi');
  const parts = text.split(regex);
  return parts.map((part, index) =>
    keywords.some(keyword => keyword.toLowerCase() === part.toLowerCase())
      ? <span key={index} className="palavra-chave">{part}</span>
      : part
  );
};

const DecolagemMarte = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { apiBaseUrl } = useConfig();
  const API_BASE_URL = apiBaseUrl;
  const { spaceCoins, setSpaceCoins, syncSpaceCoins } = useSpaceCoins();
  const alarmAudio = useMemo(() => new Audio('/sounds/evacuation-alarm.mp3'), []);

  // --- CONTROLE DE ESTADOS DO S.O.S ---
  const [usedSosIds, setUsedSosIds] = useState([]);
  const usedSosIdsRef = useRef([]);
  useEffect(() => { usedSosIdsRef.current = usedSosIds; }, [usedSosIds]);

  const playSFX = useCallback((url) => {
    try {
      const audio = new Audio(url);
      audio.play().catch(err => console.warn(`Erro ao forçar SFX ${url}:`, err));
    } catch (e) {
      console.warn(`Erro ao criar áudio ${url}:`, e);
    }
  }, []);

  const [telemetry, setTelemetry] = useState({
    velocity: { kmh: 0, ms: 0, rel: '0.0c' },
    altitude: 0,
    orbitalPosition: '0.00, 0.00, 0.00',
    orientation: { pitch: 0, yaw: 0, roll: 0 },
    coordinates: { x: 0, y: 0, z: 0 },
    battery: 100,
    powerConsumption: 0,
    powerDistribution: { lifeSupport: 40, propulsion: 50, comms: 10 },
    cabinPressure: 101.3,
    atmosphere: { o2: 100, co2: 0.4, n2: 78.3 },
    temperature: 22.1,
    humidity: 45,
    propulsion: { reactorTemp: 845, reactorPressure: 4.2, neutronFlux: '3.8e15', powerOutput: 100, controlRods: 45, steamTemp: 320 },
    comms: { status: 'ACTIVE', signalStrength: 92, antennaDirection: 'EARTH', telemetry: { sent: 1280, received: 980 } },
    sensors: { alerts: [], structuralIntegrity: 100, radiation: 0.12, nearbyObjects: 0 },
    direction: 100, stability: 100, productivity: 100, interdependence: 100, engagement: 100
  });

  const telemetryRef = useRef(telemetry);
  const spaceCoinsRef = useRef(spaceCoins);

  const [speed, setSpeed] = useState(0);
  const [isDialogueFinished, setIsDialogueFinished] = useState(false);
  const [showEscolhaModal, setShowEscolhaModal] = useState(false);
  const [showStoreModal, setShowStoreModal] = useState(false);
  const [isOxygenRefilled, setIsOxygenRefilled] = useState(false);
  const [lastImpactTimestamp, setLastImpactTimestamp] = useState(0);
  const userId = user?._id;
  const [showMandala, setShowMandala] = useState(false);
  const [minervaImage, setMinervaImage] = useState('/images/Minerva/Minerva_Active.gif');
  const [isDobraEnabled, setIsDobraEnabled] = useState(false);
  const [showGlossary, setShowGlossary] = useState(false);
  const [showTeamModal, setShowTeamModal] = useState(false);
  const [showInventory, setShowInventory] = useState(false);
  const [isShaking, setIsShaking] = useState(false);
  const [missionTime, setMissionTime] = useState(12 * 60 * 60);

  const [travelStarted, setTravelStarted] = useState(false);
  const travelStartedRef = useRef(travelStarted);

  const [progress, setProgress] = useState(0);
  const progressRef = useRef(progress);

  const [arrivedAtMars, setArrivedAtMars] = useState(false);
  const arrivedAtMarsRef = useRef(arrivedAtMars);

  const [isDobraAtivada, setIsDobraAtivada] = useState(false);
  const isDobraAtivadaRef = useRef(isDobraAtivada);

  const [monitorState, setMonitorState] = useState('on');
  const monitorStateRef = useRef(monitorState);

  const [mainDisplayState, setMainDisplayState] = useState('acee');

  const mainDisplayStateRef = useRef(mainDisplayState);

  const [plannedRoute, setPlannedRoute] = useState([]);
  const plannedRouteRef = useRef(plannedRoute);

  const [routeIndex, setRouteIndex] = useState(0);
  const routeIndexRef = useRef(routeIndex);

  const [selectedPlanet, setSelectedPlanet] = useState({ nome: 'Carregando Rota...' });
  const selectedPlanetRef = useRef(selectedPlanet);

  const [distanceKm, setDistanceKm] = useState(0);
  const distanceKmRef = useRef(distanceKm);

  // Novo estado para o acumulador de distância
  const [accumulatedDistanceKm, setAccumulatedDistanceKm] = useState(0);
  const accumulatedDistanceKmRef = useRef(0);

  const [originPlanet, setOriginPlanet] = useState({ nome: 'Terra' });
  const [isLoadingRoute, setIsLoadingRoute] = useState(true);

  const [chosenShip, setChosenShip] = useState(null);
  const chosenShipRef = useRef(chosenShip);

  const [showWarpDisabledMessage, setShowWarpDisabledMessage] = useState(false);
  const [dobraCooldownEnd, setDobraCooldownEnd] = useState(0);
  const [isTransmissionStarting, setIsTransmissionStarting] = useState(false);
  const [activeChallengeData, setActiveChallengeData] = useState(null);
  const [dialogueIndex, setDialogueIndex] = useState(0);

  const [isBoostingTo60k, setIsBoostingTo60k] = useState(false);
  const isBoostingTo60kRef = useRef(isBoostingTo60k);

  const [isFinalApproach, setIsFinalApproach] = useState(false);
  const isFinalApproachRef = useRef(isFinalApproach);

  const [showDesafioModal, setShowDesafioModal] = useState(false);
  const [modalEscolhaKey, setModalEscolhaKey] = useState(0);
  const [showStellarMap, setShowStellarMap] = useState(false);
  const [showConfirmacaoModal, setShowConfirmacaoModal] = useState(false);

  const [isDeparting, setIsDeparting] = useState(false);
  const isDepartingRef = useRef(isDeparting);

  const [isReviewing, setIsReviewing] = useState(false);
  const [refetchTrigger, setRefetchTrigger] = useState(0);
  const [showMinervaOnMonitor, setShowMinervaOnMonitor] = useState(false);
  const [groupId, setGroupId] = useState(null);

  const [isMinervaHighlighted, setIsMinervaHighlighted] = useState(false);
  const [isCooldownOver, setIsCooldownOver] = useState(true);

  const [isForcedMapEdit, setIsForcedMapEdit] = useState(false);
  const isForcedMapEditRef = useRef(isForcedMapEdit);

  const [isWarpCooldown, setIsWarpCooldown] = useState(false);
  const [showCriticalWarpFail, setShowCriticalWarpFail] = useState(false);
  const [showSOSModal, setShowSOSModal] = useState(false);
  const [sosCost, setSosCost] = useState(0);
  const [isRestoringSOS, setIsRestoringSOS] = useState(false);

  const [processadorO2, setProcessadorO2] = useState(0);
  const processadorO2Ref = useRef(processadorO2);

  // [VIRTUS] Índice das Virtudes (0 a 1), calculado no servidor e recebido
  // via /game-data. Exibido no painel como porcentagem.
  const [virtusIndex, setVirtusIndex] = useState(0);

  const [travelTime, setTravelTime] = useState(0);
  const [teamPhotoUrl, setTeamPhotoUrl] = useState(null);
  const [isSosMinervaActive, setIsSosMinervaActive] = useState(false);
  const [activeSosSignal, setActiveSosSignal] = useState(null);
  const [showO2Modal, setShowO2Modal] = useState(false);

  const [sosSurpriseEvent, setSosSurpriseEvent] = useState(null);
  const sosSurpriseEventRef = useRef(sosSurpriseEvent);

  const [showSosSurprise, setShowSosSurprise] = useState(false);
  const [playingSosVideo, setPlayingSosVideo] = useState(false);

  const minervaEventTriggered = useRef(false);
  const hideMinervaTimerRef = useRef(null);
  const boostTimerRef = useRef(null);
  const approachSoundPlayed = useRef(false);
  const minervaTimeoutRef = useRef(null);
  const dobraTimerRef = useRef(null);
  const takeoffApplied = useRef(false);
  const routeChangeLockRef = useRef(false);
  const restoreIntervalRef = useRef(null);
  const cockpitRef = useRef(null);

  const canDecreaseDistanceRef = useRef(false);

  const { playTrack, playSound, stopAllAudio, unlockAudio, fadeOutAudio } = useAudio();
  const { isPaused, togglePause } = usePause();
  const isPausedRef = useRef(isPaused);


  // --- NOVA LÓGICA DE CONTAGEM DE CORPOS CELESTES ---
  const countCorposCelestes = useMemo(() => {
    if (!plannedRoute || plannedRoute.length === 0) return 0;
    let count = 0;
    // Alterado de i = 0 para i = 1 para ignorar o planeta de origem (Terra)
    for (let i = 1; i <= routeIndex; i++) {
      if (plannedRoute[i] && plannedRoute[i].name) {
        const stepName = normalizeName(plannedRoute[i].name);
        const isStation = STATION_NAMES.some(s => stepName.includes(s));
        if (!isStation) count++;
      }
    }
    return count;
  }, [plannedRoute, routeIndex]);

  const countCorposCelestesRef = useRef(countCorposCelestes);
  useEffect(() => { countCorposCelestesRef.current = countCorposCelestes; }, [countCorposCelestes]);

  const teamData = useMemo(() => {
    const teamCode = user?.teamCode || "E1";
    return TEAMS_DATA.find(t => t.code === teamCode) || TEAMS_DATA[0];
  }, [user]);

  useEffect(() => { spaceCoinsRef.current = spaceCoins; }, [spaceCoins]);
  useEffect(() => { travelStartedRef.current = travelStarted; }, [travelStarted]);
  useEffect(() => { arrivedAtMarsRef.current = arrivedAtMars; }, [arrivedAtMars]);
  useEffect(() => { isDobraAtivadaRef.current = isDobraAtivada; }, [isDobraAtivada]);
  useEffect(() => { monitorStateRef.current = monitorState; }, [monitorState]);
  useEffect(() => { plannedRouteRef.current = plannedRoute; }, [plannedRoute]);
  useEffect(() => { routeIndexRef.current = routeIndex; }, [routeIndex]);
  useEffect(() => { progressRef.current = progress; }, [progress]);
  useEffect(() => { selectedPlanetRef.current = selectedPlanet; }, [selectedPlanet]);
  useEffect(() => { distanceKmRef.current = distanceKm; }, [distanceKm]);
  useEffect(() => { chosenShipRef.current = chosenShip; }, [chosenShip]);
  useEffect(() => { isBoostingTo60kRef.current = isBoostingTo60k; }, [isBoostingTo60k]);
  useEffect(() => { isFinalApproachRef.current = isFinalApproach; }, [isFinalApproach]);
  useEffect(() => { isDepartingRef.current = isDeparting; }, [isDeparting]);
  useEffect(() => { isForcedMapEditRef.current = isForcedMapEdit; }, [isForcedMapEdit]);
  useEffect(() => { processadorO2Ref.current = processadorO2; }, [processadorO2]);
  useEffect(() => { sosSurpriseEventRef.current = sosSurpriseEvent; }, [sosSurpriseEvent]);
  useEffect(() => { isPausedRef.current = isPaused; }, [isPaused]);
  useEffect(() => { mainDisplayStateRef.current = mainDisplayState; }, [mainDisplayState]);

  const showStoreModalRef = useRef(showStoreModal);
  useEffect(() => { showStoreModalRef.current = showStoreModal; }, [showStoreModal]);
  const showDesafioModalRef = useRef(showDesafioModal);
  useEffect(() => { showDesafioModalRef.current = showDesafioModal; }, [showDesafioModal]);
  const showEscolhaModalRef = useRef(showEscolhaModal);
  useEffect(() => { showEscolhaModalRef.current = showEscolhaModal; }, [showEscolhaModal]);
  const showSosSurpriseRef = useRef(showSosSurprise);
  useEffect(() => { showSosSurpriseRef.current = showSosSurprise; }, [showSosSurprise]);
  const showConfirmacaoModalRef = useRef(showConfirmacaoModal);
  useEffect(() => { showConfirmacaoModalRef.current = showConfirmacaoModal; }, [showConfirmacaoModal]);

  useEffect(() => {
    const videosToPreload = ["/images/Vluz-Dobra.webm", "/images/clouds.webm"];
    videosToPreload.forEach((src) => {
      const video = document.createElement("video");
      video.src = src;
      video.preload = "auto";
      video.muted = true;
      video.load();
    });
  }, []);

  useEffect(() => {
    let timer;
    if (mainDisplayState === 'stars') {
      // Mesmo critério do efeito de retomada acima: routeIndex > 0 (já
      // concluiu etapa) OU progress > 0 (retomando no meio da 1ª etapa)
      // usam o delay curto, já que não há cutscene de decolagem pra esperar.
      // Usa progressRef (não o state) para não re-disparar este efeito a
      // cada tick de progresso durante o voo.
      if (routeIndex > 0 || progressRef.current > 0) {
        timer = setTimeout(() => { canDecreaseDistanceRef.current = true; }, 4500);
      } else {
        timer = setTimeout(() => { canDecreaseDistanceRef.current = true; }, 20000);
      }
    } else {
      canDecreaseDistanceRef.current = false;
    }
    return () => { if (timer) clearTimeout(timer); };
  }, [mainDisplayState, routeIndex]);

  const triggerMinervaInterplanetarySpeed = useCallback(() => {
    minervaEventTriggered.current = true;
    if (distanceKmRef.current < 300000) return;
    setShowMinervaOnMonitor(true);
    playSFX('/sounds/Mineva-VelInterplanetaria.mp3');
    setTimeout(() => { setShowMinervaOnMonitor(false); }, 5000);
    setTimeout(() => { setIsBoostingTo60k(true); playSFX('/sounds/empuxo.wav'); }, 2000);
  }, [playSFX]);

  const constructPhotoUrl = (gameNumber, teamName) => {
    if (!gameNumber || !teamName) return null;
    const safeGame = `game_${gameNumber}`;
    const safeTeam = teamName.trim().replace(/[^a-z0-9]/gi, '_').toLowerCase();
    return `/images/grupos/${safeGame}/${safeTeam}/registro_equipe_${safeTeam}.jpg`;
  };

  const handleInventoryTelemetryUpdate = useCallback((updates) => {
    setTelemetry(prev => {
      const newPropulsion = updates.nuclearPropulsion !== undefined ? updates.nuclearPropulsion : prev.propulsion.powerOutput;
      const newO2 = updates.oxygen !== undefined ? updates.oxygen : prev.atmosphere.o2;
      const newState = {
        ...prev,
        propulsion: { ...prev.propulsion, powerOutput: newPropulsion },
        atmosphere: { ...prev.atmosphere, o2: newO2 },
        productivity: updates.productivity !== undefined ? updates.productivity : prev.productivity,
        engagement: updates.engagement !== undefined ? updates.engagement : prev.engagement,
        interdependence: updates.interdependence !== undefined ? updates.interdependence : prev.interdependence,
        stability: updates.stability !== undefined ? updates.stability : prev.stability,
        direction: updates.direction !== undefined ? updates.direction : prev.direction
      };
      telemetryRef.current = newState;
      return newState;
    });
    setLastImpactTimestamp(Date.now());
  }, []);

  const saveTelemetryData = useCallback(async () => {
    if (!userId || !API_BASE_URL) return;
    const dataToSave = {
      telemetryState: {
        oxygen: telemetryRef.current.atmosphere.o2,
        nuclearPropulsion: telemetryRef.current.propulsion.powerOutput,
        direction: telemetryRef.current.direction,
        stability: telemetryRef.current.stability,
        productivity: telemetryRef.current.productivity,
        interdependence: telemetryRef.current.interdependence,
        engagement: telemetryRef.current.engagement
      },
      distanciaPercorridaKm: accumulatedDistanceKmRef.current,
      corposCelestesVisitados: countCorposCelestesRef.current,
      distanciaRestanteKm: distanceKmRef.current // <-- ADICIONE ESTA LINHA
    };
    try {
      await fetch(`${API_BASE_URL}/${userId}/update-gamedata`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(dataToSave),
      });
    } catch (error) { console.error("ERRO: Falha ao salvar dados de telemetria:", error); }
  }, [userId, API_BASE_URL]);

  const saveTelemetryDataRef = useRef(saveTelemetryData);
  useEffect(() => { saveTelemetryDataRef.current = saveTelemetryData; }, [saveTelemetryData]);

  const saveCurrentProgress = useCallback(async (currentIndex) => {
    if (!userId || !API_BASE_URL) return;
    try {
      await fetch(`${API_BASE_URL}/${userId}/update-gamedata`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
          routeIndex: currentIndex,
          distanciaPercorridaKm: accumulatedDistanceKmRef.current,
          corposCelestesVisitados: countCorposCelestesRef.current,
          distanciaRestanteKm: distanceKmRef.current // <-- ADICIONE ESTA LINHA
        }),
      });
    } catch (error) { console.error("ERRO: Falha ao salvar progresso:", error); }
  }, [userId, API_BASE_URL]);

  const saveCurrentProgressRef = useRef(saveCurrentProgress);
  useEffect(() => { saveCurrentProgressRef.current = saveCurrentProgress; }, [saveCurrentProgress]);

  const saveNewRouteAndProgress = useCallback(async (currentIndex, newRouteArray) => {
    if (!userId || !API_BASE_URL) return;
    const dataToSave = {
      routeIndex: currentIndex,
      rotaPlanejada: newRouteArray,
      distanciaPercorridaKm: accumulatedDistanceKmRef.current,
      corposCelestesVisitados: countCorposCelestesRef.current,
      distanciaRestanteKm: distanceKmRef.current // <-- ADICIONE ESTA LINHA
    };
    try {
      await fetch(`${API_BASE_URL}/${userId}/update-gamedata`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(dataToSave),
      });
    } catch (error) { console.error("ERRO: Falha ao salvar nova rota:", error); }
  }, [userId, API_BASE_URL]);

  const handleStoreChallengeImpact = useCallback((item) => {
    playSound('/sounds/data-updates-telemetry.mp3');
    if (item.effects || item.value) {
      const impactos = item.effects ? item.effects.reduce((acc, effect) => ({ ...acc, [effect.field]: effect.value }), {}) : { [item.telemetryField]: item.value };
      const applyImpact = (currentVal, change) => Math.max(0, Math.min(100, currentVal + (change || 0)));

      setTelemetry(prev => {
        const newPropulsion = impactos.nuclearPropulsion !== undefined ? applyImpact(prev.propulsion.powerOutput, impactos.nuclearPropulsion) : prev.propulsion.powerOutput;
        const newO2 = impactos.oxygen !== undefined ? applyImpact(prev.atmosphere.o2, impactos.oxygen) : prev.atmosphere.o2;
        const newDirection = impactos.direction !== undefined ? applyImpact(prev.direction, impactos.direction) : prev.direction;
        const newStability = impactos.stability !== undefined ? applyImpact(prev.stability, impactos.stability) : prev.stability;
        const newProductivity = impactos.productivity !== undefined ? applyImpact(prev.productivity, impactos.productivity) : prev.productivity;
        const newEngagement = impactos.engagement !== undefined ? applyImpact(prev.engagement, impactos.engagement) : prev.engagement;
        const newInterdependence = impactos.interdependence !== undefined ? applyImpact(prev.interdependence, impactos.interdependence) : prev.interdependence;

        const newState = {
          ...prev,
          propulsion: { ...prev.propulsion, powerOutput: newPropulsion },
          atmosphere: { ...prev.atmosphere, o2: newO2 },
          direction: newDirection,
          stability: newStability,
          productivity: newProductivity,
          engagement: newEngagement,
          interdependence: newInterdependence
        };
        telemetryRef.current = newState;
        return newState;
      });
      setLastImpactTimestamp(Date.now());
      saveTelemetryData();
    }
  }, [playSound, saveTelemetryData]);

  const handleSosDetected = useCallback(() => {
    if (!travelStarted && routeIndex === 0) return;
    if (monitorStateRef.current !== 'on') return;
    if (isDepartingRef.current) return;
    if (isForcedMapEditRef.current) return;
    if (isPausedRef.current) return;
    if (distanceKmRef.current <= 0) return;

    setIsSosMinervaActive(true);
    setTimeout(() => { setIsSosMinervaActive(false); }, 5000);
  }, [travelStarted, routeIndex]);

  const handleChallengeEnd = useCallback(() => { }, []);
  const handleChallengeEndRef = useRef(handleChallengeEnd);
  useEffect(() => { handleChallengeEndRef.current = handleChallengeEnd; }, [handleChallengeEnd]);

  const handleMudarRota = useCallback(() => {
    //playTrack('/sounds/SUA_MUSICA_PADRAO.mp3', { loop: true, isPrimary: true });
    setShowConfirmacaoModal(false);
    setShowStoreModal(false);
    setShowSosSurprise(false);
    setSosSurpriseEvent(null);
    setIsForcedMapEdit(true);
    setShowStellarMap(true);
  }, [playTrack]);

  const handleSeguirPlano = useCallback(() => {
    if (fadeOutAudio) fadeOutAudio(2000); else stopAllAudio();
    if (dobraTimerRef.current) clearTimeout(dobraTimerRef.current);
    setShowConfirmacaoModal(false);
    setShowStoreModal(false);
    setShowSosSurprise(false);
    setSosSurpriseEvent(null);
    playSFX('/sounds/empuxo.wav');
    setIsDeparting(true);

    setTimeout(async () => {
      const currentIndex = routeIndexRef.current;
      const currentRoute = plannedRouteRef.current;
      let nextDistance = 300000000;

      if (currentRoute && currentRoute[currentIndex] && currentRoute[currentIndex + 1]) {
        setOriginPlanet({ nome: currentRoute[currentIndex].name });
        setSelectedPlanet({ nome: currentRoute[currentIndex + 1].name });
        nextDistance = currentRoute[currentIndex + 1].distance || 300000000;
        setDistanceKm(nextDistance);
      } else {
        setDistanceKm(nextDistance);
      }

      distanceKmRef.current = nextDistance;
      setProgress(0);
      setArrivedAtMars(false);
      setIsFinalApproach(false);
      approachSoundPlayed.current = false;
      minervaEventTriggered.current = true;

      triggerMinervaInterplanetarySpeed();
      setActiveChallengeData(null);
      setIsDialogueFinished(false);
      setTravelStarted(true);
      setDobraCooldownEnd(0);
      setProcessadorO2(0);
      setIsDobraEnabled(false);
      setIsDeparting(false);

      //playTrack('/sounds/SUA_MUSICA_PADRAO.mp3', { loop: true, isPrimary: true });
    }, 4000);
  }, [playSFX, triggerMinervaInterplanetarySpeed, stopAllAudio, fadeOutAudio, playTrack]);

  const handleRouteChanged = useCallback((newRouteData) => {
    if (!newRouteData || !newRouteData.newPlannedRoute || newRouteData.newRouteIndex === undefined) {
      if (!isForcedMapEdit) { setShowStellarMap(false); }
      return;
    }

    setIsForcedMapEdit(false);
    setShowStellarMap(false);
    setShowSosSurprise(false);
    setSosSurpriseEvent(null);

    const { newPlannedRoute, newRouteIndex } = newRouteData;
    const isInFlight = !arrivedAtMars && travelStarted;

    if (isInFlight) {
      routeChangeLockRef.current = true;
      saveNewRouteAndProgress(newRouteIndex, newPlannedRoute);
      setPlannedRoute(newPlannedRoute);
      setRouteIndex(newRouteIndex);

      const newOriginStep = newPlannedRoute[newRouteIndex];
      const newDestinationStep = newPlannedRoute[newRouteIndex + 1];

      if (newOriginStep && newDestinationStep) {
        setOriginPlanet({ nome: newOriginStep.name });
        setSelectedPlanet({ nome: newDestinationStep.name });
      }

      setArrivedAtMars(false);

      setTimeout(() => { routeChangeLockRef.current = false; }, 500);
    } else {
      if (fadeOutAudio) fadeOutAudio(2000); else stopAllAudio();

      playSFX('/sounds/empuxo.wav');
      setIsDeparting(true);
      setShowStoreModal(false);

      setTimeout(async () => {
        let nextDistance = 300000000;
        if (newPlannedRoute && newPlannedRoute[newRouteIndex] && newPlannedRoute[newRouteIndex + 1]) {
          setOriginPlanet({ nome: newPlannedRoute[newRouteIndex].name });
          setSelectedPlanet({ nome: newPlannedRoute[newRouteIndex + 1].name });
          nextDistance = newPlannedRoute[newRouteIndex + 1].distance || 300000000;
        }
        setDistanceKm(nextDistance);
        distanceKmRef.current = nextDistance;
        setPlannedRoute(newPlannedRoute);
        setRouteIndex(newRouteIndex);

        await saveNewRouteAndProgress(newRouteIndex, newPlannedRoute);

        setProgress(0);
        setArrivedAtMars(false);
        setIsFinalApproach(false);
        approachSoundPlayed.current = false;
        minervaEventTriggered.current = true;

        triggerMinervaInterplanetarySpeed();
        setActiveChallengeData(null);
        setIsDialogueFinished(false);
        setTravelStarted(true);
        setDobraCooldownEnd(0);
        setProcessadorO2(0);
        setIsDobraEnabled(false);
        setRefetchTrigger(prev => prev + 1);
        setIsDeparting(false);

        //playTrack('/sounds/SUA_MUSICA_PADRAO.mp3', { loop: true, isPrimary: true });
      }, 4000);
    }
    // OTIMIZAÇÃO: `distanceKm`, `routeIndex` e `plannedRoute` estavam nesta
    // lista mas não são lidos em nenhum lugar do corpo da função (o código
    // usa `newRouteData.newPlannedRoute`/`newRouteData.newRouteIndex`, que
    // vêm do argumento, e refs onde precisa do valor atual). Como
    // `distanceKm` muda a cada ~80ms durante o voo, mantê-lo aqui recriava
    // esta função o tempo todo e quebrava a memoização do TelemetryDisplay
    // (que recebe esta função via prop `onRouteChanged`). Removidos por
    // serem, de fato, dependências não usadas.
  }, [saveNewRouteAndProgress, playSFX, arrivedAtMars, travelStarted, isForcedMapEdit, triggerMinervaInterplanetarySpeed, stopAllAudio, fadeOutAudio, playTrack]);

  const handleEscolha = async (opcao, desafioId, impactos) => {
    setIsTransmissionStarting(false); setIsDialogueFinished(false);
    const coinsReward = Number(opcao.spaceCoins || 0);
    const currentCoins = Number(spaceCoins) || 0;
    const newBalance = currentCoins + coinsReward;
    if (coinsReward !== 0) setSpaceCoins(newBalance);

    if (impactos) {
      const applyImpact = (currentVal, change) => Math.max(0, Math.min(100, currentVal + (change || 0)));
      setTelemetry(prev => {
        const newPropulsion = impactos.nuclearPropulsion !== undefined ? applyImpact(prev.propulsion.powerOutput, impactos.nuclearPropulsion) : prev.propulsion.powerOutput;
        const newO2 = impactos.oxygen !== undefined ? applyImpact(prev.atmosphere.o2, impactos.oxygen) : prev.atmosphere.o2;
        const newDirection = impactos.direction !== undefined ? applyImpact(prev.direction, impactos.direction) : prev.direction;
        const newStability = impactos.stability !== undefined ? applyImpact(prev.stability, impactos.stability) : prev.stability;
        const newProductivity = impactos.productivity !== undefined ? applyImpact(prev.productivity, impactos.productivity) : prev.productivity;
        const newEngagement = impactos.engagement !== undefined ? applyImpact(prev.engagement, impactos.engagement) : prev.engagement;
        const newInterdependence = impactos.interdependence !== undefined ? applyImpact(prev.interdependence, impactos.interdependence) : prev.interdependence;

        const newState = {
          ...prev,
          propulsion: { ...prev.propulsion, powerOutput: newPropulsion },
          atmosphere: { ...prev.atmosphere, o2: newO2 },
          direction: newDirection,
          stability: newStability,
          productivity: newProductivity,
          engagement: newEngagement,
          interdependence: newInterdependence
        };
        telemetryRef.current = newState;
        return newState;
      });
      setLastImpactTimestamp(Date.now());
      saveTelemetryData();
    }

    if (!userId || !desafioId || !API_BASE_URL) return;
    try {
      const response = await fetch(`${API_BASE_URL}/record-choice`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ userId, desafioId, escolha: opcao, impactos: impactos, newBalance: newBalance }),
      });
      const result = await response.json();
      // [VIRTUS] Atualiza o indicador na hora com o valor já recalculado
      // pelo servidor nesta mesma resposta, em vez de esperar o próximo
      // fetchGameData (que só roda no mount ou na troca de rota). É isso
      // que faz o Virtus reagir "ao vivo" a cada CSD respondido.
      if (result && result.virtusIndex !== undefined) setVirtusIndex(result.virtusIndex);
    } catch (error) { console.error("ERRO: Falha ao registrar escolha:", error); }

    setIsMinervaHighlighted(true);
    setShowEscolhaModal(false); setShowConfirmacaoModal(true);
  };

  const handleDobraEspacial = useCallback(() => {
    if (!isDobraEnabled || isDobraAtivada || isPaused) return;

    if (telemetryRef.current.atmosphere.o2 <= 0 || telemetryRef.current.propulsion.powerOutput <= 0) {
      playSound('/sounds/ui-click.mp3');
      setShowCriticalWarpFail(true);
      setTimeout(() => setShowCriticalWarpFail(false), 7000);
      return;
    }

    setIsDobraAtivada(true);
    setIsDobraEnabled(false);
    setMinervaImage('/images/Minerva/Minerva-Vluz.gif');
    playSFX('/sounds/05.Dobra-Active.mp3');

    const COOLDOWN_IN_MS = 3 * 60 * 1000;
    setDobraCooldownEnd(Date.now() + COOLDOWN_IN_MS);
    const DOBRA_DURATION_IN_MS = 130 * 1000;

    if (dobraTimerRef.current) clearTimeout(dobraTimerRef.current);
    dobraTimerRef.current = setTimeout(() => {

      playSFX('/sounds/power-down-Warp.mp3');

      setTimeout(() => {
        isDobraAtivadaRef.current = false;
        setIsDobraAtivada(false);
        saveTelemetryData();
        setIsWarpCooldown(true);
        setTimeout(() => { setIsWarpCooldown(false); }, 20000);
        setShowWarpDisabledMessage(true);
        setMinervaImage('/images/Minerva/Minerva_Active.gif');
        setTimeout(() => setShowWarpDisabledMessage(false), 10000);

        const isMoon = selectedPlanetRef.current?.nome?.toLowerCase() === 'lua';
        const approachDistanceThreshold = 800000;
        const currentDist = distanceKmRef.current;

        if (!isMoon && currentDist <= approachDistanceThreshold && !isFinalApproachRef.current) {
          setIsFinalApproach(true);
          setIsBoostingTo60k(false);
          approachSoundPlayed.current = true;
        } else {
          setIsBoostingTo60k(true);
        }
      }, 200);

    }, DOBRA_DURATION_IN_MS);

    if (minervaTimeoutRef.current) clearTimeout(minervaTimeoutRef.current);
    minervaTimeoutRef.current = setTimeout(() => { setMinervaImage('/images/Minerva/Minerva_Active.gif'); }, DOBRA_DURATION_IN_MS + 3000);
  }, [isDobraEnabled, isDobraAtivada, isPaused, playSound, saveTelemetryData, playSFX]);

  const handleInventory = useCallback(() => { if (!isPaused) { setShowInventory(true); playSound('/sounds/inventory-open.mp3'); } }, [isPaused, playSound]);

  const handleTransferO2 = async () => {
    if (isPaused || processadorO2 === 0 || !userId || !API_BASE_URL) return;
    const amountToAdd = processadorO2;

    setTelemetry(prev => {
      const currentO2 = prev.atmosphere.o2;
      const newO2 = Math.min(100, currentO2 + amountToAdd);
      const newState = { ...prev, atmosphere: { ...prev.atmosphere, o2: newO2 } };
      telemetryRef.current = newState;
      return newState;
    });

    setLastImpactTimestamp(Date.now());
    playSound('/sounds/data-updates-telemetry.mp3');
    try {
      await fetch(`${API_BASE_URL}/${userId}/update-gamedata`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          processadorO2: 0,
          telemetryState: {
            ...telemetryRef.current,
            oxygen: telemetryRef.current.atmosphere.o2,
            nuclearPropulsion: telemetryRef.current.propulsion.powerOutput,
            direction: telemetryRef.current.direction,
            stability: telemetryRef.current.stability,
            productivity: telemetryRef.current.productivity,
            interdependence: telemetryRef.current.interdependence,
            engagement: telemetryRef.current.engagement
          },
          distanciaPercorridaKm: accumulatedDistanceKmRef.current,
          corposCelestesVisitados: countCorposCelestesRef.current
        }),
      });
      setProcessadorO2(0);
    } catch (error) { console.error("ERRO: Falha ao transferir O2 e salvar dados:", error); }
  };

  const handleMinervaClick = useCallback((e) => {
    if (e) e.preventDefault();
    setIsMinervaHighlighted(false);

    if (!isPaused) {
      setShowMandala(true);
    }
  }, [isPaused]);

  const handleOpenO2Modal = useCallback(() => {
    if (isPaused || processadorO2 === 0) return;
    setShowO2Modal(true);
    playSound('/sounds/ui-click.mp3');
  }, [isPaused, processadorO2, playSound]);

  const isO2TransferDisabled = isPaused || processadorO2 === 0;

  const sequenceStarted = useRef(false);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => { isMounted.current = false; };
  }, []);

  useEffect(() => {
    if (isLoadingRoute) return;

    // Retomar em pleno voo: além de routeIndex > 0 (já concluiu alguma etapa),
    // também conta progress > 0 — o jogador pode ter deslogado/fechado o
    // navegador ainda na PRIMEIRA etapa (Terra -> 1º destino), caso em que
    // routeIndex continua 0 mas ele já percorreu parte do trajeto. Sem essa
    // checagem, a cutscene inteira de decolagem (~45s) tocava de novo do
    // zero, dando a impressão de que a rota tinha reiniciado.
    // Usa progressRef (não o state) para este efeito não re-disparar a
    // cada tick de progresso durante o voo — só nos importa o valor no
    // momento em que isLoadingRoute/routeIndex muda.
    const isResumingMidFlight = routeIndex > 0 || progressRef.current > 0;

    if (isResumingMidFlight) {
      if (!sequenceStarted.current) {
        sequenceStarted.current = true;
        setMainDisplayState('stars');
        setMonitorState('on');
        setTravelStarted(true);
      }
      return;
    }

    if (!sequenceStarted.current) {
      sequenceStarted.current = true;
      unlockAudio();
      const audioUrl = `/sounds/decolagem.mp3?t=${Date.now()}`;
      playTrack(audioUrl, { loop: false, isPrimary: true });

      setTimeout(() => {
        if (isMounted.current) { setMainDisplayState('clouds'); setTravelStarted(true); }
      }, 13000);

      setTimeout(() => {
        if (isMounted.current) {
          setMainDisplayState('static');
          setMonitorState('static');
        }
      }, 23000);

      setTimeout(() => {
        if (isMounted.current) {
          stopAllAudio();
          setMainDisplayState('stars');
          setMonitorState('on');
        }
      }, 45000);
    }
  }, [isLoadingRoute, routeIndex, unlockAudio, playTrack, stopAllAudio]);

  useEffect(() => {
    if (telemetry.velocity.kmh >= 59500 && !isDobraEnabled && !isDobraAtivada && distanceKm > 500000 && !isWarpCooldown) {
      setIsDobraEnabled(true);
      playSFX('/sounds/05.Dobra-Active.mp3');
    }
  }, [telemetry.velocity.kmh, isDobraEnabled, isDobraAtivada, distanceKm, isWarpCooldown, playSFX]);

  useEffect(() => {
    if (!travelStarted && routeIndex === 0) return;
    const triggerSosEvent = () => {
      if (isDobraAtivadaRef.current) return;
      if (monitorStateRef.current !== 'on') return;
      if (distanceKmRef.current <= 0) return;
      if (isForcedMapEditRef.current) return;
      if (isPausedRef.current) return;
      if (isDepartingRef.current) return;
      if (showStoreModalRef.current || showDesafioModalRef.current || showEscolhaModalRef.current || showSosSurpriseRef.current || showConfirmacaoModalRef.current) return;

      playSFX('/sounds/minervaSOS.mp3');

      setIsSosMinervaActive(true);
      setTimeout(() => { setIsSosMinervaActive(false); }, 5000);
      const randomPlanet = PLANET_DATA_FOR_SOS[Math.floor(Math.random() * PLANET_DATA_FOR_SOS.length)];
      const offsetRadius = randomPlanet.orbitRadius + (Math.random() > 0.5 ? 4 : -4);
      const offsetAngle = Math.random() * 360;
      const newSignal = { name: `S.O.S próximo a ${randomPlanet.name}`, hostName: randomPlanet.name, angle: offsetAngle, orbitRadius: offsetRadius, distanceText: `Desconhecido` };
      setActiveSosSignal(newSignal);
      setTimeout(() => { setActiveSosSignal(null); }, 300000);
    };
    const interval = setInterval(triggerSosEvent, 180000);
    return () => clearInterval(interval);
  }, [travelStarted, routeIndex, playSFX]);

  const animationFrameId = useRef();
  const lastUpdateTime = useRef(0);
  const telemetryInterval = 100;
  const lastRenderTime = useRef(0);
  const lastDistanceRenderTime = useRef(0);

  const syncSpaceCoinsRef = useRef(syncSpaceCoins);
  useEffect(() => { syncSpaceCoinsRef.current = syncSpaceCoins; }, [syncSpaceCoins]);

  const gameNumberRef = useRef(user?.gameNumber);
  useEffect(() => { gameNumberRef.current = user?.gameNumber; }, [user?.gameNumber]);

  useEffect(() => {
    const saveIndexForCorrection = async (currentIndex) => {
      if (!userId || !API_BASE_URL) return;
      try {
        await fetch(`${API_BASE_URL}/${userId}/update-gamedata`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            routeIndex: currentIndex,
            distanciaPercorridaKm: accumulatedDistanceKmRef.current,
            corposCelestesVisitados: countCorposCelestesRef.current
          }),
        });
      } catch (error) { console.error("ERRO: Falha ao salvar correção de rota:", error); }
    };

    const fetchGameData = async () => {
      if (!userId || !API_BASE_URL) return;
      setIsLoadingRoute(true);
      try {
        const response = await fetch(`${API_BASE_URL}/${userId}/game-data?t=${Date.now()}`);
        const data = await response.json();

        if (data.success) {
          // GUARDA: sem nave escolhida, o jogador nunca deveria ter chegado
          // até a tela de decolagem — ele saiu do jogo antes de terminar a
          // Seleção de Astronave (etapa 1). Antes disto, a tela renderizava
          // normalmente com chosenShip=null e, mais abaixo, sem rota
          // planejada, caía no "Erro de Rota". Agora manda de volta para a
          // etapa correta em vez de deixar o jogador preso numa tela de voo
          // com estado incompleto.
          if (!data.naveEscolhida) {
            navigate('/selecaonave', { replace: true });
            return;
          }

          if (data._id) setGroupId(data._id);
          if (data.naveEscolhida) setChosenShip(data.naveEscolhida);
          if (data.spaceCoins !== undefined) syncSpaceCoinsRef.current(data.spaceCoins);
          if (data.processadorO2 !== undefined) setProcessadorO2(data.processadorO2);
          if (data.virtusIndex !== undefined) setVirtusIndex(data.virtusIndex);

          if (data.distanciaPercorridaKm != null) {
            const safeDistance = Number(data.distanciaPercorridaKm) || 0;
            setAccumulatedDistanceKm(safeDistance);
            accumulatedDistanceKmRef.current = safeDistance;
          }

          if (data.sosHistory) {
            setUsedSosIds(data.sosHistory);
            usedSosIdsRef.current = data.sosHistory;
          }

          let photo = data.photoUrl;
          if (!photo && gameNumberRef.current && data.teamName) {
            photo = constructPhotoUrl(gameNumberRef.current, data.teamName);
          }
          if (photo) setTeamPhotoUrl(photo);

          const currentRouteIndex = data.routeIndex || 0;
          if (data.rotaPlanejada && data.rotaPlanejada.length > 1) {
            const routeFromDB = data.rotaPlanejada;
            const originStep = routeFromDB[currentRouteIndex];
            const nextStep = routeFromDB[currentRouteIndex + 1];
            if (!originStep || !nextStep) {
              await saveIndexForCorrection(0);
              setRefetchTrigger(prev => prev + 1);
              return;
            }
            setRouteIndex(currentRouteIndex);
            setPlannedRoute(routeFromDB);
            setOriginPlanet({ nome: originStep.name });
            setSelectedPlanet({ nome: nextStep.name });

            // LÊ A DISTÂNCIA RESTANTE EXATA DO BANCO DE DADOS
            // BUGFIX: `distanciaRestanteKm` vem do servidor como 0 (não
            // `undefined`) tanto para uma perna que o jogador JÁ completou
            // quanto para uma rota recém-planejada que ele nunca chegou a
            // voar (o schema/documento no Mongo inicializa esse campo em 0
            // em vez de deixá-lo ausente). Antes, `!== undefined` tratava
            // esse 0 "de fábrica" como "restam 0km", ou seja: a perna já
            // nascia com distância zerada. Isso fazia o loop de jogo (que
            // considera newDistance <= 0 como chegada) marcar o jogador
            // como "chegado" no planeta de destino sem ele ter voado nada,
            // avançar o routeIndex e salvar de volta distanciaRestanteKm=0
            // para a PRÓXIMA perna — repetindo o problema a cada novo login
            // e fazendo o jogador "pular" de planeta em planeta na rota. Um
            // valor <= 0 (ou ausente/inválido) agora é tratado como "esta
            // perna ainda não foi percorrida" e cai para a distância cheia
            // do trecho; só um valor > 0 salvo é considerado progresso real.
            const storedRemainingKm = Number(data.distanciaRestanteKm);
            const distFromDB = Number.isFinite(storedRemainingKm) && storedRemainingKm > 0
              ? storedRemainingKm
              : (nextStep.distance || 0);
            setDistanceKm(distFromDB);
            distanceKmRef.current = distFromDB;

            // --- ADICIONE ESTAS 4 LINHAS PARA CORRIGIR O ROUTE MONITOR ---
            const initialDistanceForLeg = nextStep.distance || 1;
            const distanceTraveled = initialDistanceForLeg - distFromDB;
            const progressPercentage = Math.max(0, Math.min((distanceTraveled / initialDistanceForLeg) * 100, 100));
            setProgress(progressPercentage);
            // -------------------------------------------------------------

          } else {
            // Nave escolhida, mas rota planejada nunca foi definida (saiu do
            // jogo antes de terminar a Seleção de Rota Estelar, etapa 4).
            // Mesma lógica do guard acima: manda de volta pra etapa certa em
            // vez de mostrar a tela de voo travada em "Erro de Rota".
            navigate('/SelecaoRota', { replace: true });
            return;
          }
          if (data.telemetryState) {
            telemetryRef.current = { ...telemetryRef.current, ...data.telemetryState, atmosphere: { ...telemetryRef.current.atmosphere, o2: data.telemetryState.oxygen ?? 100 }, propulsion: { ...telemetryRef.current.propulsion, powerOutput: data.telemetryState.nuclearPropulsion ?? 100 } };
            setTelemetry({ ...telemetryRef.current });
          }
        } else {
          setSelectedPlanet({ nome: "Erro de Rota" });
        }
      } catch (error) {
        console.error("ERRO: Falha no fetchGameData:", error);
        setSelectedPlanet({ nome: "Erro de Conexão" });
      } finally {
        setIsLoadingRoute(false);
      }
    };
    fetchGameData();
  }, [userId, API_BASE_URL, refetchTrigger]);


  useEffect(() => {
    if (isPaused || !chosenShip || isDobraAtivada) return;
    const rates = degradationRates[chosenShip] || degradationRates.default;
    const intervals = [];
    const createInterval = (key, telemetryPath, rateInMinutes) => {
      const intervalId = setInterval(() => {
        let currentValue = telemetryPath.split('.').reduce((o, i) => o[i], telemetryRef.current);
        const newValue = Math.max(0, currentValue - 1);
        let refPath = telemetryRef.current;
        const pathParts = telemetryPath.split('.');
        for (let i = 0; i < pathParts.length - 1; i++) {
          refPath = refPath[pathParts[i]];
        }
        refPath[pathParts.length - 1] = newValue;
        setTelemetry(prev => ({ ...prev, ...telemetryRef.current }));
      }, rateInMinutes * 60 * 1000);
      intervals.push(intervalId);
    };
    createInterval('nuclearPropulsion', 'propulsion.powerOutput', rates.nuclearPropulsion);
    createInterval('oxygen', 'atmosphere.o2', rates.oxygen);
    createInterval('direction', 'direction', rates.direction);
    createInterval('stability', 'stability', rates.stability);
    createInterval('productivity', 'productivity', rates.productivity);
    createInterval('interdependence', 'interdependence', rates.interdependence);
    createInterval('engagement', 'engagement', rates.engagement);
    return () => intervals.forEach(clearInterval);
  }, [isPaused, chosenShip, isDobraAtivada]);

  useEffect(() => {
    if (!isDobraAtivada || isPaused) return;
    const warpConsumptionInterval = setInterval(() => {
      const newPropulsion = Math.max(0, telemetryRef.current.propulsion.powerOutput - 1);
      const newO2 = Math.max(0, telemetryRef.current.atmosphere.o2 - 1);
      telemetryRef.current.propulsion.powerOutput = newPropulsion;
      telemetryRef.current.atmosphere.o2 = newO2;
      setTelemetry(prev => ({ ...prev, ...telemetryRef.current }));
      if (newPropulsion <= 0 || newO2 <= 0) {
        if (dobraTimerRef.current) clearTimeout(dobraTimerRef.current);
        isDobraAtivadaRef.current = false;
        setIsDobraAtivada(false);
        setShowCriticalWarpFail(true);
        setTimeout(() => setShowCriticalWarpFail(false), 7000);
      }
    }, 20000);
    return () => clearInterval(warpConsumptionInterval);
  }, [isDobraAtivada, isPaused]);

  useEffect(() => {
    let delayTimer, takeoffInterval;
    if (chosenShip && originPlanet.nome === 'Terra' && !takeoffApplied.current) {
      takeoffApplied.current = true;
      delayTimer = setTimeout(() => {
        const ratesForShip = takeoffDegradation[chosenShip] || takeoffDegradation.default;
        const takeoffDurationInSeconds = 66;
        const lossPerSecond = {
          propulsion: ratesForShip.propulsion / takeoffDurationInSeconds,
          direction: ratesForShip.direction / takeoffDurationInSeconds,
          stability: ratesForShip.stability / takeoffDurationInSeconds,
        };
        let ticks = 0;
        takeoffInterval = setInterval(() => {
          if (ticks >= takeoffDurationInSeconds) { clearInterval(takeoffInterval); return; }
          telemetryRef.current.propulsion.powerOutput = Math.max(0, telemetryRef.current.propulsion.powerOutput - lossPerSecond.propulsion);
          telemetryRef.current.direction = Math.max(0, telemetryRef.current.direction - lossPerSecond.direction);
          telemetryRef.current.stability = Math.max(0, telemetryRef.current.stability - lossPerSecond.stability);
          setTelemetry(prev => ({ ...prev, ...telemetryRef.current }));
          ticks++;
        }, 1000);
      }, 11000);
    }
    return () => { clearTimeout(delayTimer); clearInterval(takeoffInterval); };
  }, [chosenShip, originPlanet.nome]);

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => { if (travelStarted) setTravelTime(prev => prev + 1); }, 1000);
    return () => clearInterval(interval);
  }, [isPaused, travelStarted]);

  useEffect(() => {
    if (isPaused || !travelStarted || minervaEventTriggered.current) return;
    if (travelTime >= 60) {
      triggerMinervaInterplanetarySpeed();
    }
  }, [travelTime, travelStarted, isPaused, triggerMinervaInterplanetarySpeed]);

  useEffect(() => {
    if (isPaused || isDobraAtivada || isLoadingRoute || travelTime === 0) return;
    const isMoon = selectedPlanet?.nome?.toLowerCase() === 'lua';
    const approachDistanceThreshold = 800000;

    if (distanceKm <= 1000 && distanceKm > 0 && !isFinalApproachRef.current) {
      setIsFinalApproach(true);
      setIsBoostingTo60k(false);
    }

    if (!isMoon && distanceKm <= approachDistanceThreshold && distanceKm > 0 && !approachSoundPlayed.current) {
      playSFX('/sounds/empuxo.wav');
      approachSoundPlayed.current = true;
      setIsFinalApproach(true);
      setIsBoostingTo60k(false);
    }
  }, [distanceKm, isDobraAtivada, selectedPlanet, isPaused, isLoadingRoute, playSFX, travelTime]);

  const isSystemCritical = telemetry.atmosphere.o2 <= 20 || telemetry.propulsion.powerOutput <= 20 || telemetry.direction <= 20 || telemetry.stability <= 20 || telemetry.productivity <= 20 || telemetry.interdependence <= 20 || telemetry.engagement <= 20;
  const hasFundsForSOS = (spaceCoins || 0) > 0;
  const isSOSActive = isSystemCritical && !isPaused && !isDobraAtivada && !isRestoringSOS && hasFundsForSOS;

  const handleSOS = useCallback(() => {
    if (!isSOSActive) return;
    const minutesPlayed = travelTime / 60;
    const calculatedCost = Math.floor(minutesPlayed) + 5000000;
    const finalCost = Math.min(calculatedCost, spaceCoins || 0);
    setSosCost(finalCost);
    setShowSOSModal(true);
    playSound('/sounds/ui-click.mp3');
  }, [isSOSActive, travelTime, spaceCoins, playSound]);

  const handleConfirmSOS = () => {
    setSpaceCoins(prev => (prev || 0) - sosCost);
    setIsRestoringSOS(true);
    playSound('/sounds/ui-click.mp3');
    setShowSOSModal(false);
  };
  const handleCancelSOS = () => setShowSOSModal(false);

  useEffect(() => {
    const isCritical = (telemetry.atmosphere.o2 <= 20 || telemetry.propulsion.powerOutput <= 20 || telemetry.direction <= 20 || telemetry.stability <= 20 || telemetry.productivity <= 20 || telemetry.interdependence <= 20 || telemetry.engagement <= 20) && !isRestoringSOS;
    alarmAudio.loop = true;
    if (isCritical && !isPaused) { if (alarmAudio.paused) alarmAudio.play().catch(e => console.warn("Erro ao tocar alarme:", e)); }
    else { alarmAudio.pause(); alarmAudio.currentTime = 0; }
    return () => { alarmAudio.pause(); };
    // OTIMIZAÇÃO: dependíamos do objeto `telemetry` inteiro, que ganha uma
    // referência nova a cada ~100ms durante o voo (inclusive quando só a
    // velocidade muda, o que não afeta este efeito). Isso disparava
    // play()/pause() no áudio do alarme 10x por segundo. Agora dependemos só
    // dos campos que realmente decidem se o alarme toca.
  }, [
    telemetry.atmosphere.o2,
    telemetry.propulsion.powerOutput,
    telemetry.direction,
    telemetry.stability,
    telemetry.productivity,
    telemetry.interdependence,
    telemetry.engagement,
    isPaused,
    isRestoringSOS,
    alarmAudio
  ]);

  useEffect(() => {
    if (isRestoringSOS && !isPaused) {
      // OTIMIZAÇÃO: era um setInterval de 50ms (20 renders/s) — de longe o
      // timer mais agressivo do jogo, bem mais frequente que o game loop
      // (throttled a ~10-12/s). Trocado para 150ms/+6, que restaura na
      // MESMA velocidade total (2 a cada 50ms = 6 a cada 150ms), só que com
      // 1/3 dos renders enquanto o S.O.S. está ativo.
      restoreIntervalRef.current = setInterval(() => {
        let anyChanged = false;
        let allFull = true;
        const restoreValue = (currentVal) => {
          if (currentVal < 100) { anyChanged = true; allFull = false; return Math.min(100, currentVal + 6); }
          return currentVal;
        };

        telemetryRef.current.atmosphere.o2 = restoreValue(telemetryRef.current.atmosphere.o2);
        telemetryRef.current.propulsion.powerOutput = restoreValue(telemetryRef.current.propulsion.powerOutput);
        telemetryRef.current.direction = restoreValue(telemetryRef.current.direction);
        telemetryRef.current.stability = restoreValue(telemetryRef.current.stability);
        telemetryRef.current.productivity = restoreValue(telemetryRef.current.productivity);
        telemetryRef.current.interdependence = restoreValue(telemetryRef.current.interdependence);
        telemetryRef.current.engagement = restoreValue(telemetryRef.current.engagement);

        if (anyChanged) setTelemetry({ ...telemetryRef.current });

        if (allFull) { clearInterval(restoreIntervalRef.current); setIsRestoringSOS(false); saveTelemetryData(); }
      }, 150);
    } else if (isPaused && restoreIntervalRef.current) { clearInterval(restoreIntervalRef.current); }
    return () => { if (restoreIntervalRef.current) clearInterval(restoreIntervalRef.current); };
  }, [isRestoringSOS, isPaused, saveTelemetryData]);

  // ========================================================
  // OTIMIZAÇÃO CRÍTICA: GAME LOOP REFATORADO
  // ========================================================
  useEffect(() => {
    const gameLoop = (timestamp) => {
      if (isPausedRef.current) {
        lastUpdateTime.current = timestamp;
        animationFrameId.current = requestAnimationFrame(gameLoop);
        return;
      }

      try {
        if (lastUpdateTime.current === 0) lastUpdateTime.current = timestamp;
        const deltaTime = timestamp - lastUpdateTime.current;

        if (deltaTime >= telemetryInterval) {
          lastUpdateTime.current = timestamp - (deltaTime % telemetryInterval);
          const dobraAtiva = isDobraAtivadaRef.current;
          const accelConfig = accelerationRates[chosenShipRef.current] || accelerationRates.default;
          const WARP_MULTIPLIER = 21.000;

          let targetSpeed = 45000;
          if (dobraAtiva) { targetSpeed = 100000000; }
          else if (isBoostingTo60kRef.current) { targetSpeed = 60000; }
          else if (isFinalApproachRef.current) { targetSpeed = 45000; }

          let newKmh;
          const currentSpeed = telemetryRef.current.velocity.kmh;

          if (dobraAtiva) {
            const warpAcceleration = Math.floor(accelConfig.perTick * WARP_MULTIPLIER);
            newKmh = currentSpeed + warpAcceleration;
          } else {
            let speedChange = accelConfig.perTick;

            if (mainDisplayStateRef.current !== 'stars' && currentSpeed < targetSpeed) {
              speedChange = Math.max(450, accelConfig.perTick * 5);
            }

            if (currentSpeed > 65000) { newKmh = 60000; }
            else {
              if (currentSpeed < targetSpeed) { newKmh = Math.min(currentSpeed + speedChange, targetSpeed); }
              else { let brakePower = speedChange * 2; newKmh = Math.max(currentSpeed - brakePower, targetSpeed); }
            }
          }

          if (travelStartedRef.current) {
            const SPEED_OF_LIGHT_KMH = 1079252848.8;

            if (timestamp - lastRenderTime.current > 100) {
              telemetryRef.current = {
                ...telemetryRef.current,
                velocity: {
                  kmh: newKmh,
                  ms: newKmh / 3.6,
                  rel: `${(newKmh / SPEED_OF_LIGHT_KMH).toFixed(7)}c`
                }
              };
              setTelemetry(telemetryRef.current);
              lastRenderTime.current = timestamp;
            } else {
              telemetryRef.current.velocity.kmh = newKmh;
              telemetryRef.current.velocity.ms = newKmh / 3.6;
              telemetryRef.current.velocity.rel = `${(newKmh / SPEED_OF_LIGHT_KMH).toFixed(7)}c`;
            }
          }
        }

        if (travelStartedRef.current && !routeChangeLockRef.current && canDecreaseDistanceRef.current) {
          const currentSpeedKmh = telemetryRef.current.velocity.kmh;
          let distanceToDecrease = 0;

          const nextLeg = plannedRouteRef.current?.[routeIndexRef.current + 1];
          const isShortTrip = nextLeg && nextLeg.distance < 2000000;
          const distanceScale = isShortTrip ? 0.05 : 1;

          if (currentSpeedKmh >= 60000) {
            distanceToDecrease = ((currentSpeedKmh * 9172) / 3000 / 3.125) * distanceScale;
          } else {
            distanceToDecrease = ((currentSpeedKmh * 8000) / 3000 / 3.125) * distanceScale;
            if (distanceToDecrease < (2500 * distanceScale)) distanceToDecrease = (2500 * distanceScale);
          }

          // LÓGICA DE ACÚMULO DE DISTÂNCIA - CORRIGIDA
          if (distanceKmRef.current > 0 && !arrivedAtMarsRef.current) {
            const actualTraveled = Math.min(distanceToDecrease, distanceKmRef.current);
            accumulatedDistanceKmRef.current += actualTraveled;
          }

          const newDistance = Math.max(0, distanceKmRef.current - distanceToDecrease);
          distanceKmRef.current = newDistance;

          // OTIMIZAÇÃO: este bloco inteiro (a partir do `if
          // (travelStartedRef.current...` acima) roda em TODO frame do game
          // loop, ou seja, a até 60x por segundo — ele não é protegido pelo
          // throttle de `telemetryInterval` (100ms) usado para velocidade.
          // `shouldRenderDistanceUpdate` guarda essa decisão de ~80ms (already
          // usada para `setDistanceKm`) para reaproveitar mais abaixo no
          // `setProgress`, que antes era chamado sem nenhum throttle e forçava
          // o componente `DecolagemMarte` inteiro (painéis, telemetria, mapa)
          // a re-renderizar 60x/s durante todo o voo — mesmo com os filhos
          // memoizados, o próprio render do componente pai já custava caro
          // rodando nessa frequência. A barra de progresso não perde suavidade
          // visível atualizando ~12.5x/s em vez de 60x/s.
          const shouldRenderDistanceUpdate = timestamp - lastDistanceRenderTime.current > 80;
          if (shouldRenderDistanceUpdate) {
            setDistanceKm(Math.round(newDistance));
            setAccumulatedDistanceKm(accumulatedDistanceKmRef.current);
            lastDistanceRenderTime.current = timestamp;
          }

          const selPlanet = selectedPlanetRef.current;
          const isSosDestination = selPlanet && selPlanet.nome && selPlanet.nome.startsWith("S.O.S");

          if (isSosDestination && !isForcedMapEditRef.current) {
            if (newDistance <= 1000 && newDistance > 0 && !sosSurpriseEventRef.current) {

              const availableEvents = SOS_EVENTS_LIST.filter(ev => !usedSosIdsRef.current.includes(ev.id));

              if (availableEvents.length > 0) {
                const randIndex = Math.floor(Math.random() * availableEvents.length);
                const selectedEvent = availableEvents[randIndex];

                setSosSurpriseEvent(selectedEvent);
                sosSurpriseEventRef.current = selectedEvent;

                fetch(`${API_BASE_URL}/${userId}/record-sos-history`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ sosId: selectedEvent.id })
                }).catch(err => console.error("Erro ao salvar S.O.S no histórico:", err));

                setUsedSosIds(prev => [...prev, selectedEvent.id]);
              }
            }

            if (newDistance <= 0 && !arrivedAtMarsRef.current) {
              setArrivedAtMars(true); setSpeed(0);

              playTrack('/sounds/nick/nick.mp3', { loop: true, isPrimary: true });

              if (!sosSurpriseEventRef.current) {
                const availableEvents = SOS_EVENTS_LIST.filter(ev => !usedSosIdsRef.current.includes(ev.id));
                if (availableEvents.length > 0) {
                  const randIndex = Math.floor(Math.random() * availableEvents.length);
                  const selectedEvent = availableEvents[randIndex];

                  setSosSurpriseEvent(selectedEvent);
                  sosSurpriseEventRef.current = selectedEvent;

                  fetch(`${API_BASE_URL}/${userId}/record-sos-history`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ sosId: selectedEvent.id })
                  }).catch(err => console.error("Erro ao salvar S.O.S no histórico:", err));

                  setUsedSosIds(prev => [...prev, selectedEvent.id]);
                }
              }

              const newRouteIndex = routeIndexRef.current + 1;
              setRouteIndex(newRouteIndex);
              saveCurrentProgressRef.current(newRouteIndex);

              setPlayingSosVideo(true);
            }
          }

          if (newDistance <= 150000 && isDobraAtivadaRef.current) {
            if (dobraTimerRef.current) clearTimeout(dobraTimerRef.current);

            isDobraAtivadaRef.current = false;
            setIsDobraAtivada(false);
            setIsFinalApproach(true);
            setIsBoostingTo60k(false);
            approachSoundPlayed.current = true;
            saveTelemetryDataRef.current();
            setShowWarpDisabledMessage(true);
            setMinervaImage('/images/Minerva/Minerva_Active.gif');

            playSFX('/sounds/power-down-Warp.mp3');
            setTimeout(() => playSFX('/sounds/empuxo.wav'), 800);

            setTimeout(() => setShowWarpDisabledMessage(false), 10000);
            setIsWarpCooldown(true);
            setTimeout(() => { setIsWarpCooldown(false); }, 20000);
          } else if (newDistance <= 0 && !arrivedAtMarsRef.current && !isForcedMapEditRef.current && !isSosDestination) {

            setArrivedAtMars(true); setSpeed(45000);
            arrivedAtMarsRef.current = true;

            const targetName = normalizeName(selPlanet.nome);
            const isStation = STATION_NAMES.some(s => targetName.includes(s));

            if (isStation) {
              setTimeout(() => { setShowStoreModal(true); }, 2500);
            } else {
              const desafioEncontrado = desafiosData.desafios?.find(d =>
                normalizeName(d.planeta) === targetName ||
                (selPlanet.desafioId && d.id === selPlanet.desafioId)
              );

              if (desafioEncontrado) {
                setActiveChallengeData(desafioEncontrado);
                setDialogueIndex(0);
                setShowDesafioModal(true);
              } else {
                console.warn("⚠️ Desafio não encontrado para o destino:", targetName);
                setActiveChallengeData(null);
                setTimeout(() => {
                  setShowConfirmacaoModal(true);
                }, 5000);
              }
            }

            let newProcessadorO2Value = processadorO2Ref.current;
            let earnedCoins = 0;
            const planetNameInput = selPlanet?.nome || '';
            const hasWater = Array.from(hasWaterList).some(p => p.toLowerCase() === planetNameInput.toLowerCase().trim());

            if (hasWater) {
              const o2Bonus = Math.floor(Math.random() * 5) + 1;
              newProcessadorO2Value = Math.min(5, processadorO2Ref.current + o2Bonus);
              earnedCoins = o2Bonus * 10000;
            }

            const newRouteIndex = routeIndexRef.current + 1;

            (async () => {
              await saveCurrentProgressRef.current(newRouteIndex);
              try {
                const currentCoins = spaceCoinsRef.current || 0;
                const newCoinsValue = currentCoins + earnedCoins;

                const bodyData = {
                  routeIndex: newRouteIndex,
                  processadorO2: newProcessadorO2Value,
                  distanciaPercorridaKm: accumulatedDistanceKmRef.current,
                  corposCelestesVisitados: countCorposCelestesRef.current,
                  telemetryState: {
                    oxygen: telemetryRef.current.atmosphere.o2,
                    nuclearPropulsion: telemetryRef.current.propulsion.powerOutput,
                    direction: telemetryRef.current.direction,
                    stability: telemetryRef.current.stability,
                    productivity: telemetryRef.current.productivity,
                    interdependence: telemetryRef.current.interdependence,
                    engagement: telemetryRef.current.engagement
                  }
                };

                if (earnedCoins > 0) {
                  bodyData.spaceCoins = newCoinsValue;
                }

                await fetch(`${API_BASE_URL}/${userId}/update-gamedata`, {
                  method: 'POST', headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(bodyData),
                });

                if (earnedCoins > 0) { setSpaceCoins(newCoinsValue); }
              } catch (error) { console.error("ERRO", error); }
              setProcessadorO2(newProcessadorO2Value); setRouteIndex(newRouteIndex); handleChallengeEndRef.current();
            })();
          }

          if (shouldRenderDistanceUpdate) {
            const destinationStepIndex = routeIndexRef.current + 1;
            const initialDistanceForLeg = (plannedRouteRef.current && plannedRouteRef.current[destinationStepIndex] ? plannedRouteRef.current[destinationStepIndex].distance : null) || newDistance || 1;
            const distanceTraveled = initialDistanceForLeg - newDistance;
            const progressPercentage = Math.min((distanceTraveled / initialDistanceForLeg) * 100, 100);
            setProgress(progressPercentage);
          }
        }
      } catch (fatalError) {
        console.error("Game Loop Anti-Crash ativado.", fatalError);
      }

      animationFrameId.current = requestAnimationFrame(gameLoop);
    };

    animationFrameId.current = requestAnimationFrame(gameLoop);
    return () => cancelAnimationFrame(animationFrameId.current);
  }, [API_BASE_URL, userId, playSFX, playTrack]);

  // ========================================================
  // AUTO-SAVE DA DISTÂNCIA PERCORRIDA E RESTANTE (15 seg)
  // ========================================================
  useEffect(() => {
    // Se o jogo estiver pausado ou a viagem não começou, não faz nada
    if (isPaused || !travelStarted) return;

    const autoSaveInterval = setInterval(() => {
      if (!userId || !API_BASE_URL) return;

      // Só salva se a distância acumulada já for maior que zero
      if (accumulatedDistanceKmRef.current > 0) {
        fetch(`${API_BASE_URL}/${userId}/update-gamedata`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            distanciaPercorridaKm: accumulatedDistanceKmRef.current,
            corposCelestesVisitados: countCorposCelestesRef.current,
            distanciaRestanteKm: distanceKmRef.current // Salva o ponto exato da viagem
          }),
        }).catch(err => console.error("Erro no auto-save de distância:", err));
      }
    }, 15000);

    // Limpa o cronômetro se o componente for desmontado ou pausado
    return () => clearInterval(autoSaveInterval);
  }, [isPaused, travelStarted, userId, API_BASE_URL]);

  // ========================================================
  // SALVAMENTO GARANTIDO AO FECHAR A ABA/NAVEGADOR
  // (não existe botão de "Sair" — o jogador simplesmente fecha o
  // navegador, então isso funciona como o "logout" do jogo.
  // Sem isso, até 15s de progresso do auto-save acima podem se
  // perder. O RouteMonitor lê distanceKm/progress derivados
  // exatamente destes campos no próximo login, via fetchGameData.)
  // ========================================================
  useEffect(() => {
    const flushProgressOnExit = () => {
      if (!userId || !API_BASE_URL || !travelStartedRef.current) return;

      const payload = {
        routeIndex: routeIndexRef.current,
        distanciaPercorridaKm: accumulatedDistanceKmRef.current,
        distanciaRestanteKm: distanceKmRef.current, // ponto exato da viagem (usado pelo RouteMonitor ao retomar)
        corposCelestesVisitados: countCorposCelestesRef.current,
        telemetryState: {
          oxygen: telemetryRef.current.atmosphere.o2,
          nuclearPropulsion: telemetryRef.current.propulsion.powerOutput,
          direction: telemetryRef.current.direction,
          stability: telemetryRef.current.stability,
          productivity: telemetryRef.current.productivity,
          interdependence: telemetryRef.current.interdependence,
          engagement: telemetryRef.current.engagement
        }
      };

      const url = `${API_BASE_URL}/${userId}/update-gamedata`;

      try {
        if (navigator.sendBeacon) {
          // sendBeacon é assíncrono e sobrevive ao fechamento da aba,
          // diferente de fetch/axios que podem ser abortados pelo navegador.
          const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
          navigator.sendBeacon(url, blob);
        } else {
          // Fallback para navegadores sem suporte a sendBeacon
          fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            keepalive: true
          }).catch(() => { });
        }
      } catch (e) {
        console.error("Erro ao salvar progresso final antes de sair:", e);
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') flushProgressOnExit();
    };

    // pagehide cobre fechamento de aba/navegador (inclusive mobile);
    // beforeunload cobre navegação/recarregamento em desktop;
    // visibilitychange é uma rede de segurança extra para quando
    // nenhum dos dois eventos dispara a tempo (comum em mobile).
    window.addEventListener('pagehide', flushProgressOnExit);
    window.addEventListener('beforeunload', flushProgressOnExit);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('pagehide', flushProgressOnExit);
      window.removeEventListener('beforeunload', flushProgressOnExit);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [userId, API_BASE_URL]);

  const currentMaxSpeed = useMemo(() => {
    if (isDobraAtivada) return 100000000;
    if (isBoostingTo60k) return 60000;
    if (isFinalApproach) return 45000;
    return 45000;
  }, [isDobraAtivada, isBoostingTo60k, isFinalApproach]);

  const isPauseButtonDisabled = telemetry.velocity.kmh < 60000 || isDobraAtivada || distanceKm <= 0;

  const currentDialogueStep = activeChallengeData?.dialogo?.[dialogueIndex];
  const currentCharacterId = currentDialogueStep?.personagemId;
  const currentCharacterData = currentCharacterId ? desafiosData.personagens[currentCharacterId] : null;

  const handleCloseEscolhaModal = useCallback(() => { setShowEscolhaModal(false); }, []);

  const handleSpendCoins = useCallback((amount, type) => {
    setSpaceCoins(prev => (prev || 0) - amount);

    if (type === 'all') {
      setShowDesafioModal(true);
      setShowEscolhaModal(false);
      setIsTransmissionStarting(false);
      setIsDialogueFinished(false);
      setDialogueIndex(0);
    }
  }, [setSpaceCoins]);

  const handleReplayDialogue = useCallback(() => {
    if (activeChallengeData) { setDialogueIndex(0); setIsTransmissionStarting(true); setIsDialogueFinished(false); }
  }, [activeChallengeData]);

  const handleNextDialogue = useCallback(() => {
    if (!activeChallengeData || !activeChallengeData.dialogo) return;
    if (dialogueIndex < activeChallengeData.dialogo.length - 1) {
      setDialogueIndex(prev => prev + 1);
      playSound('/sounds/ui-click.mp3');
    } else {
      setIsTransmissionStarting(false);
      setIsDialogueFinished(true);
      setShowEscolhaModal(true);
      setDialogueIndex(0);
    }
  }, [activeChallengeData, dialogueIndex, playSound]);

  useEffect(() => {
    if (!isTransmissionStarting || !activeChallengeData || !activeChallengeData.dialogo) return;

    if (activeChallengeData.dialogo.length === 0) {
      setIsTransmissionStarting(false);
      setIsDialogueFinished(true);
      setShowEscolhaModal(true);
      return;
    }

    const currentStep = activeChallengeData.dialogo[dialogueIndex];
    if (!currentStep) return;

    const duration = currentStep.duracao || (currentStep.texto.length * 50 + 2000);
    const timer = setTimeout(() => { handleNextDialogue(); }, duration);

    return () => clearTimeout(timer);
  }, [dialogueIndex, isTransmissionStarting, activeChallengeData, handleNextDialogue]);

  // OTIMIZAÇÃO: usava `distanceKm` (state) na dependência, que muda a cada
  // ~80ms durante o voo — isso recriava esta função a cada tick e, por
  // consequência, quebrava a memoização do TelemetryDisplay (que recebe
  // esta função via prop `setShowStellarMap`). Trocamos para os refs, que
  // sempre têm o valor atual sem precisar recriar a função.
  const handleToggleMap = useCallback((show) => {
    if (show) {
      if (distanceKmRef.current <= 0 && !isForcedMapEditRef.current) { playSound('/sounds/error.mp3'); return; }
    }
    setShowStellarMap(show);
  }, [playSound]);

  // --- CENTRAL DE ATALHOS ---
  useEffect(() => {
    const handleGlobalHotkeys = (e) => {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;

      const key = e.key.toLowerCase();

      switch (key) {
        case ' ':
          e.preventDefault();
          if (!isDobraEnabled || isDobraAtivada || isPaused) return;
          handleDobraEspacial();
          break;

        case 'p':
          e.preventDefault();
          if (!isPauseButtonDisabled && !isRestoringSOS) togglePause();
          break;

        case 's':
          e.preventDefault();
          if (isSOSActive) handleSOS();
          break;

        case 'i':
          e.preventDefault();
          handleInventory();
          break;

        case 'g':
          e.preventDefault();
          if (!isPaused) setShowGlossary(true);
          break;

        case 'm':
          e.preventDefault();
          if (isPaused) return;

          if (isForcedMapEditRef.current) {
            handleToggleMap(true);
            break;
          }

          if (distanceKmRef.current > 0 && (isDobraAtivadaRef.current || telemetryRef.current.velocity.kmh < 60000)) {
            return;
          }

          handleToggleMap(true);
          break;

        case 'a':
          e.preventDefault();
          handleMinervaClick();
          break;

        case 'o':
          e.preventDefault();
          if (!isO2TransferDisabled) handleOpenO2Modal();
          break;

        default:
          break;
      }
    };

    window.addEventListener('keydown', handleGlobalHotkeys);
    return () => {
      window.removeEventListener('keydown', handleGlobalHotkeys);
    };
  }, [
    handleDobraEspacial, isDobraEnabled, isDobraAtivada, isPaused,
    togglePause, isPauseButtonDisabled, isRestoringSOS,
    handleSOS, isSOSActive,
    handleInventory,
    setShowGlossary,
    handleToggleMap,
    handleMinervaClick,
    handleOpenO2Modal, isO2TransferDisabled
  ]);

  if (isLoadingRoute) return <div className="tela-decolagem" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '1.5em', color: '#00aaff', textShadow: '0 0 10px #00aaff' }}>Buscando dados da missão...</div>;

  return (
    <div className={`tela-decolagem ${isShaking ? 'shaking' : ''}`}>
      <div ref={cockpitRef} className="cockpit-container">

        {chosenShip && (
          <div className="ship-status-display">
            <img src={getShipImage(chosenShip)} className="ship-status-image" />
            <div className="ship-status-name">{chosenShip}</div>

            <div className="ship-status-divider"></div>

            <div className="ship-info-stats" style={{ flex: 1 }}>
              <TypewriterText label="Corpos celestes visitados" value={countCorposCelestes.toString().padStart(2, '0')} />
              <TypewriterText label="Virtus" value={`${virtusIndex.toFixed(3).replace('.', ',')}`} />

              {/* === EXIBIÇÃO DA DISTÂNCIA EM UA === */}
              <div className="telemetry-distance-display" title={`${(accumulatedDistanceKm / 149597870).toFixed(8)} UA`}>
                Dist. Percorrida (UA): {(accumulatedDistanceKm / 149597870).toFixed(8)}
              </div>
            </div>

            {/* A SEGUNDA DIV 'ship-status-divider' FOI REMOVIDA DAQUI PARA TIRAR A BARRA INFERIOR */}

            {/* === RADAR OCULTO === */}
            {/* O Radar dinâmico e seus detritos foram comentados para liberar o espaço */}
            {/* <div className="radar-container">
              <DynamicRadar
                progress={progress}
                origin={originPlanet}
                destination={selectedPlanet}
                sosSignal={(distanceKm > 0 || isForcedMapEdit) ? activeSosSignal : null}
              />
            </div>
            */}
          </div>
        )}

        <LeftControlPanel
          telemetry={telemetry}
          distanceKm={distanceKm}
          progress={progress}
          isDobraAtivada={isDobraAtivada}
          isDobraEnabled={isDobraEnabled}
          isPaused={isPaused}
          originPlanet={originPlanet.nome}
          destinationPlanet={selectedPlanet.nome}
          maxSpeed={currentMaxSpeed}
          isBoosting={isBoostingTo60k}
          handleDobraEspacial={handleDobraEspacial}
          handleInventory={handleInventory}
          minervaImage={minervaImage}
          handleMinervaClick={handleMinervaClick}
          isMinervaHighlighted={isMinervaHighlighted}
          processadorO2={processadorO2}
          isO2TransferDisabled={isO2TransferDisabled}
          handleOpenO2Modal={handleOpenO2Modal}
          mainDisplayState={mainDisplayState}
        />
        <RightMonitorPanel
          isPaused={isPaused}
          isTransmissionStarting={isTransmissionStarting}
          isDialogueFinished={isDialogueFinished}
          handleReplayDialogue={handleReplayDialogue}
          handleNextDialogue={handleNextDialogue}
          monitorState={monitorState}
          showMinervaOnMonitor={showMinervaOnMonitor}
          showCriticalWarpFail={showCriticalWarpFail}
          showWarpDisabledMessage={showWarpDisabledMessage}
          isForcedMapEdit={isForcedMapEdit}
          isSosMinervaActive={isSosMinervaActive}
          isDeparting={isDeparting}
          currentCharacterData={currentCharacterData}
          currentDialogueStep={currentDialogueStep}
          highlightKeywords={highlightKeywords}
          setShowGlossary={setShowGlossary}
          setShowTeamModal={setShowTeamModal}
          handleInventory={handleInventory}
          teamPhotoUrl={teamPhotoUrl}
          API_BASE_URL={API_BASE_URL}
          isSOSActive={isSOSActive}
          handleSOS={handleSOS}
          hasFundsForSOS={hasFundsForSOS}
          isRestoringSOS={isRestoringSOS}
          togglePause={togglePause}
          isPauseButtonDisabled={isPauseButtonDisabled}
        />
        <div className="cockpit-overlay"></div>
        <MainDisplayWindow
          mainDisplayState={mainDisplayState}
          isDobraAtivada={isDobraAtivada}
          distanceKm={distanceKm}
          arrivedAtMars={arrivedAtMars}
          isPaused={isPaused}
          selectedPlanet={selectedPlanet}
          handleChallengeEnd={handleChallengeEnd}
          isDeparting={isDeparting}
          showStoreModal={showStoreModal}
          showSosSurprise={showSosSurprise}
          sosSurpriseEvent={sosSurpriseEvent}
          handleSeguirPlano={handleSeguirPlano}
          handleMudarRota={handleMudarRota}
          handleStoreChallengeImpact={handleStoreChallengeImpact}
          telemetry={telemetry}
          plannedRoute={plannedRoute}
          routeIndex={routeIndex}
        />
        <TelemetryDisplay
          data={telemetry}
          isPaused={isPaused}
          showStellarMap={showStellarMap}
          setShowStellarMap={handleToggleMap}
          onRouteChanged={handleRouteChanged}
          isDobraAtivada={isDobraAtivada}
          plannedRoute={plannedRoute}
          routeIndex={routeIndex}
          isOxygenRefilled={isOxygenRefilled}
          lastImpactTimestamp={lastImpactTimestamp}
          isForcedMapEdit={isForcedMapEdit}
          onSosDetected={handleSosDetected}
          distanceKm={distanceKm}
          sosSignalData={(distanceKm > 0 || isForcedMapEdit) ? activeSosSignal : null}
        />
      </div>
      {showMandala && (<div className="modal-overlay"><div className="modal-content"><MandalaVirtudes onClose={() => setShowMandala(false)} groupId={groupId} /></div></div>)}
      {showGlossary && (<div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}><div className="modal-content" style={{ backgroundColor: 'rgba(0, 30, 60, 0.97)', padding: '20px', borderRadius: '8px', maxWidth: '800px', width: '90%', maxHeight: '80vh', overflow: 'auto', position: 'relative' }}><Suspense fallback={<div>Carregando...</div>}><GalacticVirtudesPage onClose={() => setShowGlossary(false)} /></Suspense></div></div>)}
      {showInventory && <Inventario onClose={() => setShowInventory(false)} onUpdateTelemetry={handleInventoryTelemetryUpdate} currentTelemetry={telemetry} />}
      {showDesafioModal && activeChallengeData && <ModalDesafio desafio={activeChallengeData} onClose={() => { setShowDesafioModal(false); setIsTransmissionStarting(true); }} className="main-display-modal" showTimer={true} />}
      {showEscolhaModal && activeChallengeData && <ModalEscolha key={modalEscolhaKey} desafio={activeChallengeData} onClose={handleCloseEscolhaModal} onEscolha={handleEscolha} missionTime={travelTime} onSpendCoins={handleSpendCoins} showTimer={!isReviewing} />}
      {showConfirmacaoModal && (
        <ModalConfirmacaoViagem
          onSeguirPlano={handleSeguirPlano}
          onMudarRota={handleMudarRota}
          hasRoute={plannedRoute && (routeIndex + 1) < plannedRoute.length}
          isArrivalWithoutChallenge={!activeChallengeData}
        />
      )}
      {showSOSModal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ maxWidth: '500px', textAlign: 'center', fontFamily: "'Courier New', monospace" }}>
            <h3 style={{ color: '#fff' }}>S.O.S. RECOVERY SYSTEM</h3>
            <p style={{ color: '#fff', fontSize: '1.1em', lineHeight: '1.5' }}>Para recuperar a integridade de <strong style={{ color: '#00ff00' }}> TODOS OS SISTEMAS </strong> da nave, custará o valor de <strong style={{ color: 'yellow', fontSize: '1.1em' }}> {sosCost.toLocaleString('pt-BR')} SpaceCoins</strong>.</p>
            <p style={{ color: '#fff', fontSize: '1.1em', lineHeight: '1.5' }}>Você aceita?</p>
            <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '30px' }}>
              <button type="button" onClick={handleCancelSOS} style={{ padding: '10px 20px', background: 'linear-gradient(145deg, #ff8c00, #e67300)', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontFamily: "'Courier New', monospace", fontWeight: 'bold', fontSize: '1em' }}>Cancelar</button>
              <button type="button" onClick={handleConfirmSOS} style={{ padding: '10px 20px', background: 'linear-gradient(145deg, #00a800, #008500)', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontFamily: "'Courier New', monospace", fontWeight: 'bold', fontSize: '1em' }}>OK</button>
            </div>
          </div>
        </div>
      )}
      {showO2Modal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ maxWidth: '500px', textAlign: 'center', fontFamily: "'Courier New', monospace", color: '#fff', border: '2px solid #0bf', boxShadow: '0 0 20px #0bf' }}>
            <h3 style={{ textShadow: '0 0 10px #0bf' }}>TRANSFERÊNCIA DE OXIGÊNIO</h3>
            <p style={{ fontSize: '1.1em', margin: '20px 0' }}>
              Deseja transferir <strong style={{ color: '#0bf' }}>{processadorO2} unidades</strong> do Processador de <strong style={{ fontSize: '1.3em', color: '#0bf', textShadow: '0 0 8px #0bf' }}>O</strong><sub style={{ fontSize: '0.77em', verticalAlign: 'sub', color: '#0bf', textShadow: '0 0 8px #0bf' }}>2</sub> para o suporte de vida da nave?
            </p>
            <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '30px' }}>
              <button type="button" onClick={() => setShowO2Modal(false)} style={{ padding: '10px 20px', background: '#444', color: 'white', border: '1px solid #777', borderRadius: '4px', cursor: 'pointer', fontFamily: "'Courier New', monospace", fontWeight: 'bold' }}>CANCELAR</button>
              <button type="button" onClick={() => { handleTransferO2(); setShowO2Modal(false); }} style={{ padding: '10px 20px', background: 'linear-gradient(145deg, #0055ff, #0033cc)', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontFamily: "'Courier New', monospace", fontWeight: 'bold', boxShadow: '0 0 10px #0055ff' }}>CONFIRMAR</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL DA TRIPULAÇÃO */}
      {showTeamModal && teamData && (
        <div className="modal-overlay" style={{ zIndex: 1002 }}>
          <div className="modal-content team-modal-details">
            <button type="button" className="close-button" onClick={() => setShowTeamModal(false)}>×</button>
            <h2 style={{ color: '#ff9800', textAlign: 'center', marginBottom: '5px' }}>EQUIPE {teamData.code}</h2>
            <p style={{ textAlign: 'center', color: '#aaa', marginBottom: '20px' }}>{teamData.description}</p>

            <div className="team-grid_equipe">
              {teamData.members.map((member, index) => (
                <div key={index} className="team-member_equipe">
                  <img
                    src={`/images/Astronautas/${teamData.code}/${getMemberImage(teamData.code, index)}.png`}
                    alt={member.name}
                    className="team-member-avatar"
                  />
                  <div className="team-member-details">
                    <div className="team-member-role">{member.role}</div>
                    <div className="team-member-name-container">
                      <span style={{ color: '#fff', fontSize: '14px', fontWeight: 'bold' }}>{member.name}</span>
                    </div>
                    <div className="team-member-experience">
                      {member.experience} - {member.details}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* OVERLAY DO VÍDEO DE S.O.S FULLSCREEN */}
      {playingSosVideo && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: 99999,
          backgroundColor: '#000',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <video
            src="/images/SOS/nick.webm"
            autoPlay
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            onEnded={() => {
              setPlayingSosVideo(false);
              // BUGFIX: quando o grupo já usou as 4 histórias de
              // SOS_EVENTS_LIST, sosSurpriseEvent fica null (nenhuma
              // sobrou pra sortear na chegada) e o SosSurpriseModal nunca
              // renderiza — o JSX dele exige `showSosSurprise &&
              // sosSurpriseEvent` ao mesmo tempo. Sem este fallback, o
              // vídeo do Nick terminava e o jogador ficava travado: nave
              // parada, sem modal, sem nenhum botão que chame
              // handleSeguirPlano/handleMudarRota pra retomar a viagem.
              // Quando não sobrou história, reaproveita o mesmo modal
              // genérico já usado na chegada normal sem desafio
              // encontrado (ModalConfirmacaoViagem), que sabe continuar
              // no plano ou mudar de rota.
              if (sosSurpriseEvent) {
                setShowSosSurprise(true);
              } else {
                setActiveChallengeData(null);
                setShowConfirmacaoModal(true);
              }
            }}
          />
        </div>
      )}
    </div>
  );
};


export default DecolagemMarte;